export default {

  'Lorenzo Musetti': {
    displayName: 'Lorenzo Musetti',
    logoUrl: 'flags/italy.webp',
  },
  'Lorenzo Sonego': {
    displayName: 'Lorenzo Sonego',
    logoUrl: 'flags/italy.webp',
  },
  'Corentin Moutet': {
    displayName: 'Corentin Moutet',
    logoUrl: 'flags/france.webp',
  },
  'Gabriel Diallo': {
    displayName: 'Gabriel Diallo',
    logoUrl: 'flags/canada.webp',
  },
  'Alex de Minaur': {
    displayName: 'Alex de Minaur',
    logoUrl: 'flags/australia.webp',
  },
  'Joao Fonseca': {
    displayName: 'Joao Fonseca',
    logoUrl: 'flags/brazil.webp',
  },
  'Daniil Medvedev': {
    displayName: 'Daniil Medvedev',
    logoUrl: 'flags/russia.webp',
  },
  'Ben Shelton': {
    displayName: 'Ben Shelton',
    logoUrl: 'flags/united_states.webp',
  },
  'Andrey Rublev': {
    displayName: 'Andrey Rublev',
    logoUrl: 'flags/russia.webp',
  },
  'Cameron Norrie': {
    displayName: 'Cameron Norrie',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Valentin Vacherot': {
    displayName: 'Valentin Vacherot',
    logoUrl: 'flags/monaco.webp',
  },
  'Alycia Parks': {
    displayName: 'Alycia Parks',
    logoUrl: 'flags/united_states.webp',
  },
  'Kaja Juvan': {
    displayName: 'Kaja Juvan',
    logoUrl: 'flags/slovenia.webp',
  },
  'Dominika Salkova': {
    displayName: 'Dominika Salkova',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Anastasia Zakharova': {
    displayName: 'Anastasia Zakharova',
    logoUrl: 'flags/russia.webp',
  },
  'Anna Bondar': {
    displayName: 'Anna Bondar',
    logoUrl: 'flags/hungary.webp',
  },
  'Anna Kalinskaya': {
    displayName: 'Anna Kalinskaya',
    logoUrl: 'flags/russia.webp',
  },
  'Shuai Zhang': {
    displayName: 'Shuai Zhang',
    logoUrl: 'flags/china.webp',
  },
  'Belinda Bencic': {
    displayName: 'Belinda Bencic',
    logoUrl: 'flags/switzerland.webp',
  },
  'Yafan Wang': {
    displayName: 'Yafan Wang',
    logoUrl: 'flags/china.webp',
  },
  'Arina Rodionova': {
    displayName: 'Arina Rodionova',
    logoUrl: 'flags/australia.webp',
  },
  'Storm Hunter': {
    displayName: 'Storm Hunter',
    logoUrl: 'flags/australia.webp',
  },
  'Zhuoxuan Bai': {
    displayName: 'Zhuoxuan Bai',
    logoUrl: 'flags/china.webp',
  },
  'Hanyu Guo': {
    displayName: 'Hanyu Guo',
    logoUrl: 'flags/china.webp',
  },
  'Janice Tjen': {
    displayName: 'Janice Tjen',
    logoUrl: 'flags/indonesia.webp',
  },
  'Alexandra Eala': {
    displayName: 'Alexandra Eala',
    logoUrl: 'flags/philippines.webp',
  },
  'Victoria Mboko': {
    displayName: 'Victoria Mboko',
    logoUrl: 'flags/canada.webp',
  },
  'Joanna Garland': {
    displayName: 'Joanna Garland',
    logoUrl: 'flags/taiwan.webp',
  },
  'Mei Yamaguchi': {
    displayName: 'Mei Yamaguchi',
    logoUrl: 'flags/japan.webp',
  },
  'Himeno Sakatsume': {
    displayName: 'Himeno Sakatsume',
    logoUrl: 'flags/japan.webp',
  },
  'Eudice Chong': {
    displayName: 'Eudice Chong',
    logoUrl: 'flags/hong_kong.webp',
  },
  'Kimberly Birrell': {
    displayName: 'Kimberly Birrell',
    logoUrl: 'flags/australia.webp',
  },
  'Shrivalli Bhamidipaty': {
    displayName: 'Shrivalli Bhamidipaty',
    logoUrl: 'flags/india.webp',
  },
  'Lilli Tagger': {
    displayName: 'Lilli Tagger',
    logoUrl: 'flags/austria.webp',
  },
  'Tamara Korpatsch': {
    displayName: 'Tamara Korpatsch',
    logoUrl: 'flags/germany.webp',
  },
  'Yuliya Putintseva': {
    displayName: 'Yuliya Putintseva',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Viktorija Golubic': {
    displayName: 'Viktorija Golubic',
    logoUrl: 'flags/switzerland.webp',
  },
  'Jannik Sinner': {
    displayName: 'Jannik Sinner',
    logoUrl: 'flags/italy.webp',
  },
  'J Sinner': {
    displayName: 'J Sinner',
    logoUrl: 'flags/italy.webp',
  },
  'Alejandro Davidovich Fokina': {
    displayName: 'Alejandro Davidovich Fokina',
    logoUrl: 'flags/spain.webp',
  },
  'Alexander Zverev': {
    displayName: 'Alexander Zverev',
    logoUrl: 'flags/germany.webp',
  },
  'Lanlana Tararudee': {
    displayName: 'Lanlana Tararudee',
    logoUrl: 'flags/thailand.webp',
  },
  'Mia Pohankova': {
    displayName: 'Mia Pohankova',
    logoUrl: 'flags/slovakia.webp',
  },
  'Diane Parry': {
    displayName: 'Diane Parry',
    logoUrl: 'flags/france.webp',
  },
  'Cristina Bucsa': {
    displayName: 'Cristina Bucsa',
    logoUrl: 'flags/spain.webp',
  },
  'Leylah Annie Fernandez': {
    displayName: 'Leylah Annie Fernandez',
    logoUrl: 'flags/canada.webp',
  },
  'Sorana Cirstea': {
    displayName: 'Sorana Cirstea',
    logoUrl: 'flags/romania.webp',
  },
  'Yulia Putintseva': {
    displayName: 'Yulia Putintseva',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Kyrian Jacquet': {
    displayName: 'Kyrian Jacquet',
    logoUrl: 'flags/france.webp',
  },
  'Luca Van Assche': {
    displayName: 'Luca Van Assche',
    logoUrl: 'flags/france.webp',
  },
  'Mackenzie McDonald': {
    displayName: 'Mackenzie McDonald',
    logoUrl: 'flags/united_states.webp',
  },
  'Tomas Martin Etcheverry': {
    displayName: 'Tomas Martin Etcheverry',
    logoUrl: 'flags/argentina.webp',
  },
  'Alexander Blockx': {
    displayName: 'Alexander Blockx',
    logoUrl: 'flags/belgium.webp',
  },
  'Daniel Altmaier': {
    displayName: 'Daniel Altmaier',
    logoUrl: 'flags/germany.webp',
  },
  'Yannick Hanfmann': {
    displayName: 'Yannick Hanfmann',
    logoUrl: 'flags/germany.webp',
  },
  'Ivan Ivanov': {
    displayName: 'Ivan Ivanov',
    logoUrl: 'flags/bulgaria.webp',
  },
  'Sebastian Korda': {
    displayName: 'Sebastian Korda',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Damir Dzumhur': {
    displayName: 'Damir Dzumhur',
    logoUrl: 'flags/bosnia_and_herzegovina.webp',
  },
  'Aleksandar Vukic': {
    displayName: 'Aleksandar Vukic',
    logoUrl: 'flags/australia.webp',
  },
  'Marcos Giron': {
    displayName: 'Marcos Giron',
    logoUrl: 'flags/united_states.webp',
  },
  'Pedro Martinez': {
    displayName: 'Pedro Martinez',
    logoUrl: 'flags/dominican_republic.webp',
  },
  'Novak Djokovic': {
    displayName: 'Novak Djokovic',
    logoUrl: 'flags/serbia.webp',
  },
  'Eliot Spizzirri': {
    displayName: 'Eliot Spizzirri',
    logoUrl: 'flags/united_states.webp',
  },
  'Nuno Borges': {
    displayName: 'Nuno Borges',
    logoUrl: 'flags/portugal.webp',
  },
  'Arthur Cazaux': {
    displayName: 'Arthur Cazaux',
    logoUrl: 'flags/france.webp',
  },
  'Vitaliy Sachko': {
    displayName: 'Vitaliy Sachko',
    logoUrl: 'flags/ukraine.webp',
  },
  'Alexander Bublik': {
    displayName: 'Alexander Bublik',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Learner Tien': {
    displayName: 'Learner Tien',
    logoUrl: 'flags/united_states.webp',
  },
  'Moez Echargui': {
    displayName: 'Moez Echargui',
    logoUrl: 'flags/tunisia.webp',
  },
  'Luciano Darderi': {
    displayName: 'Luciano Darderi',
    logoUrl: 'flags/italy.webp',
  },
  'Stan Wawrinka': {
    displayName: 'Stan Wawrinka',
    logoUrl: 'flags/switzerland.webp',
  },
  'Coco Gauff': {
    displayName: 'Coco Gauff',
    logoUrl: 'flags/united_states.webp',
  },
  'Jasmine Paolini': {
    displayName: 'Jasmine Paolini',
    logoUrl: 'flags/italy.webp',
  },
  'Aryna Sabalenka': {
    displayName: 'Aryna Sabalenka',
    logoUrl: 'flags/belarus.webp',
  },
  'Jessica Pegula': {
    displayName: 'Jessica Pegula',
    logoUrl: 'flags/united_states.webp',
  },
  'Elena Rybakina': {
    displayName: 'Elena Rybakina',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Madison Keys': {
    displayName: 'Madison Keys',
    logoUrl: 'flags/united_states.webp',
  },
  'Iga Swiatek': {
    displayName: 'Iga Swiatek',
    logoUrl: 'flags/poland.webp',
  },
  'Amanda Anisimova': {
    displayName: 'Amanda Anisimova',
    logoUrl: 'flags/united_states.webp',
  },
  'Maya Joint': {
    displayName: 'Maya Joint',
    logoUrl: 'flags/australia.webp',
  },
  'Donna Vekic': {
    displayName: 'Donna Vekic',
    logoUrl: 'flags/croatia.webp',
  },
  'Polina Iatcenko': {
    displayName: 'Polina Iatcenko',
    logoUrl: 'flags/russia.webp',
  },
  'Brandon Nakashima': {
    displayName: 'Brandon Nakashima',
    logoUrl: 'flags/united_states.webp',
  },
  'Elina Svitolina': {
    displayName: 'Elina Svitolina',
    logoUrl: 'flags/ukraine.webp',
  },
  'Xinyu Wang': {
    displayName: 'Xinyu Wang',
    logoUrl: 'flags/china.webp',
  },
  'Qinwen Zheng': {
    displayName: 'Qinwen Zheng',
    logoUrl: 'flags/china.webp',
  },
  'Marta Kostyuk': {
    displayName: 'Marta Kostyuk',
    logoUrl: 'flags/ukraine.webp',
  },
  'Tristan Boyer': {
    displayName: 'Tristan Boyer',
    logoUrl: 'flags/united_states.webp',
  },
  'Gonzalo Bueno': {
    displayName: 'Gonzalo Bueno',
    logoUrl: 'flags/peru.webp',
  },
  'Pierre-Hugues Herbert': {
    displayName: 'Pierre-Hugues Herbert',
    logoUrl: 'flags/france.webp',
  },
  'Benjamin Hassan': {
    displayName: 'Benjamin Hassan',
    logoUrl: 'flags/lebanon.webp',
  },
  'Jaime Faria': {
    displayName: 'Jaime Faria',
    logoUrl: 'flags/portugal.webp',
  },
  'Rei Sakamoto': {
    displayName: 'Rei Sakamoto',
    logoUrl: 'flags/japan.webp',
  },
  'Colton Smith': {
    displayName: 'Colton Smith',
    logoUrl: 'flags/united_states.webp',
  },
  'Brandon Holt': {
    displayName: 'Brandon Holt',
    logoUrl: 'flags/united_states.webp',
  },
  'Giulio Zeppieri': {
    displayName: 'Giulio Zeppieri',
    logoUrl: 'flags/italy.webp',
  },
  'Dino Prizmic': {
    displayName: 'Dino Prizmic',
    logoUrl: 'flags/croatia.webp',
  },
  'Gustavo Heide': {
    displayName: 'Gustavo Heide',
    logoUrl: 'flags/brazil.webp',
  },
  'Henrique Rocha': {
    displayName: 'Henrique Rocha',
    logoUrl: 'flags/portugal.webp',
  },
  'Marco Trungelliti': {
    displayName: 'Marco Trungelliti',
    logoUrl: 'flags/argentina.webp',
  },
  'Yoshihito Nishioka': {
    displayName: 'Yoshihito Nishioka',
    logoUrl: 'flags/japan.webp',
  },
  'George Loffhagen': {
    displayName: 'George Loffhagen',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Jerome Kym': {
    displayName: 'Jerome Kym',
    logoUrl: 'flags/switzerland.webp',
  },
  'Dane Sweeny': {
    displayName: 'Dane Sweeny',
    logoUrl: 'flags/australia.webp',
  },
  'Martin Damm Jr': {
    displayName: 'Martin Damm Jr',
    logoUrl: 'flags/united_states.webp',
  },
  'Martin Damm': {
    displayName: 'Martin Damm',
    logoUrl: 'flags/united_states.webp',
  },
  'Duncan Chan': {
    displayName: 'Duncan Chan',
    logoUrl: 'flags/canada.webp',
  },
  'Titouan Droguet': {
    displayName: 'Titouan Droguet',
    logoUrl: 'flags/france.webp',
  },
  'Roberto Carballes Baena': {
    displayName: 'Roberto Carballes Baena',
    logoUrl: 'flags/spain.webp',
  },
  'Gilles Arnaud Bailly': {
    displayName: 'Gilles Arnaud Bailly',
    logoUrl: 'flags/belgium.webp',
  },
  'Nishesh Basavareddy': {
    displayName: 'Nishesh Basavareddy',
    logoUrl: 'flags/united_states.webp',
  },
  'Sebastian Ofner': {
    displayName: 'Sebastian Ofner',
    logoUrl: 'flags/austria.webp',
  },
  'Dusan Lajovic': {
    displayName: 'Dusan Lajovic',
    logoUrl: 'flags/serbia.webp',
  },
  'Murphy Cassone': {
    displayName: 'Murphy Cassone',
    logoUrl: 'flags/united_states.webp',
  },
  'Daniil Glinka': {
    displayName: 'Daniil Glinka',
    logoUrl: 'flags/estonia.webp',
  },
  'Daniel Merida': {
    displayName: 'Daniel Merida',
    logoUrl: 'flags/spain.webp',
  },
  'Lukas Klein': {
    displayName: 'Lukas Klein',
    logoUrl: 'flags/slovakia.webp',
  },
  'Bernard Tomic': {
    displayName: 'Bernard Tomic',
    logoUrl: 'flags/australia.webp',
  },
  'Jenson Brooksby': {
    displayName: 'Jenson Brooksby',
    logoUrl: 'flags/united_states.webp',
  },
  'Sebastian Baez': {
    displayName: 'Sebastian Baez',
    logoUrl: 'flags/argentina.webp',
  },
  'Reilly Opelka': {
    displayName: 'Reilly Opelka',
    logoUrl: 'flags/united_states.webp',
  },
  'Tommy Paul': {
    displayName: 'Tommy Paul',
    logoUrl: 'flags/united_states.webp',
  },
  'Jaume Munar': {
    displayName: 'Jaume Munar',
    logoUrl: 'flags/spain.webp',
  },
  'Thanasi Kokkinakis': {
    displayName: 'Thanasi Kokkinakis',
    logoUrl: 'flags/australia.webp',
  },
  'Tallon Griekspoor': {
    displayName: 'Tallon Griekspoor',
    logoUrl: 'flags/netherlands.webp',
  },
  'Ugo Humbert': {
    displayName: 'Ugo Humbert',
    logoUrl: 'flags/france.webp',
  },
  'Yuliia Starodubtseva': {
    displayName: 'Yuliia Starodubtseva',
    logoUrl: 'flags/ukraine.webp',
  },
  'Despina Papamichail': {
    displayName: 'Despina Papamichail',
    logoUrl: 'flags/greece.webp',
  },
  'Julia Riera': {
    displayName: 'Julia Riera',
    logoUrl: 'flags/argentina.webp',
  },
  'Viktoria Hruncakova': {
    displayName: 'Viktoria Hruncakova',
    logoUrl: 'flags/slovakia.webp',
  },
  'Viktoriya Tomova': {
    displayName: 'Viktoriya Tomova',
    logoUrl: 'flags/bulgaria.webp',
  },
  'Lucia Bronzetti': {
    displayName: 'Lucia Bronzetti',
    logoUrl: 'flags/italy.webp',
  },
  'Mary Stoiana': {
    displayName: 'Mary Stoiana',
    logoUrl: 'flags/united_states.webp',
  },
  'Guiomar Maristany Zuleta de Reales': {
    displayName: 'Guiomar Maristany Zuleta de Reales',
    logoUrl: 'flags/spain.webp',
  },
  'Tatiana Prozorova': {
    displayName: 'Tatiana Prozorova',
    logoUrl: 'flags/russia.webp',
  },
  'Justina Mikulskyte': {
    displayName: 'Justina Mikulskyte',
    logoUrl: 'flags/lithuania.webp',
  },
  'Anastasia Gasanova': {
    displayName: 'Anastasia Gasanova',
    logoUrl: 'flags/russia.webp',
  },
  'Elvina Kalieva': {
    displayName: 'Elvina Kalieva',
    logoUrl: 'flags/united_states.webp',
  },
  'Yexin MA': {
    displayName: 'Yexin MA',
    logoUrl: 'flags/china.webp',
  },
  'Elisabetta Cocciaretto': {
    displayName: 'Elisabetta Cocciaretto',
    logoUrl: 'flags/italy.webp',
  },
  'Ann Li': {
    displayName: 'Ann Li',
    logoUrl: 'flags/united_states.webp',
  },
  'Olivia Gadecki': {
    displayName: 'Olivia Gadecki',
    logoUrl: 'flags/australia.webp',
  },
  'Lizette Cabrera': {
    displayName: 'Lizette Cabrera',
    logoUrl: 'flags/australia.webp',
  },
  'Linda Klimovicova': {
    displayName: 'Linda Klimovicova',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Maja Chwalinska': {
    displayName: 'Maja Chwalinska',
    logoUrl: 'flags/poland.webp',
  },
  'Fiona Ferro': {
    displayName: 'Fiona Ferro',
    logoUrl: 'flags/france.webp',
  },
  'Anouk Koevermans': {
    displayName: 'Anouk Koevermans',
    logoUrl: 'flags/netherlands.webp',
  },
  'Anhelina Kalinina': {
    displayName: 'Anhelina Kalinina',
    logoUrl: 'flags/ukraine.webp',
  },
  'Greet Minnen': {
    displayName: 'Greet Minnen',
    logoUrl: 'flags/belgium.webp',
  },
  'Harmony Tan': {
    displayName: 'Harmony Tan',
    logoUrl: 'flags/france.webp',
  },
  'Carol Young Suh Lee': {
    displayName: 'Carol Young Suh Lee',
    logoUrl: 'flags/northern_mariana_islands.webp',
  },
  'Elena Micic': {
    displayName: 'Elena Micic',
    logoUrl: 'flags/australia.webp',
  },
  'Daria Kasatkina': {
    displayName: 'Daria Kasatkina',
    logoUrl: 'flags/russia.webp',
  },
  'Jaqueline Cristian': {
    displayName: 'Jaqueline Cristian',
    logoUrl: 'flags/romania.webp',
  },
  'Marketa Vondrousova': {
    displayName: 'Marketa Vondrousova',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Rebecca Sramkova': {
    displayName: 'Rebecca Sramkova',
    logoUrl: 'flags/slovakia.webp',
  },
  'Taylah Preston': {
    displayName: 'Taylah Preston',
    logoUrl: 'flags/australia.webp',
  },
  'Victoria Jimenez Kasintseva': {
    displayName: 'Victoria Jimenez Kasintseva',
    logoUrl: 'flags/andorra.webp',
  },
  'V Jimenez Kasintseva': {
    displayName: 'V Jimenez Kasintseva',
    logoUrl: 'flags/andorra.webp',
  },
  'Katherine Sebov': {
    displayName: 'Katherine Sebov',
    logoUrl: 'flags/canada.webp',
  },
  'Lin Zhu': {
    displayName: 'Lin Zhu',
    logoUrl: 'flags/china.webp',
  },
  'Nikola Bartunkova': {
    displayName: 'Nikola Bartunkova',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Tina Nadine Smith': {
    displayName: 'Tina Nadine Smith',
    logoUrl: 'flags/australia.webp',
  },
  'Teodora Kostovic': {
    displayName: 'Teodora Kostovic',
    logoUrl: 'flags/serbia.webp',
  },
  'Marina Stakusic': {
    displayName: 'Marina Stakusic',
    logoUrl: 'flags/canada.webp',
  },
  'Taylor Townsend': {
    displayName: 'Taylor Townsend',
    logoUrl: 'flags/united_states.webp',
  },
  'Jazmin Ortenzi': {
    displayName: 'Jazmin Ortenzi',
    logoUrl: 'flags/argentina.webp',
  },
  'Whitney Osuigwe': {
    displayName: 'Whitney Osuigwe',
    logoUrl: 'flags/united_states.webp',
  },
  'Lucrezia Stefanini': {
    displayName: 'Lucrezia Stefanini',
    logoUrl: 'flags/italy.webp',
  },
  'Tereza Valentova': {
    displayName: 'Tereza Valentova',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Lola Radivojevic': {
    displayName: 'Lola Radivojevic',
    logoUrl: 'flags/serbia.webp',
  },
  'Aliaksandra Sasnovich': {
    displayName: 'Aliaksandra Sasnovich',
    logoUrl: 'flags/belarus.webp',
  },
  'Kathinka Von Deichmann': {
    displayName: 'Kathinka Von Deichmann',
    logoUrl: 'flags/liechtenstein.webp',
  },
  'Lina Gjorcheska': {
    displayName: 'Lina Gjorcheska',
    logoUrl: 'flags/north_macedonia.webp',
  },
  'Tamara Zidansek': {
    displayName: 'Tamara Zidansek',
    logoUrl: 'flags/slovenia.webp',
  },
  'Darja Vidmanova': {
    displayName: 'Darja Vidmanova',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Maria Carle': {
    displayName: 'Maria Carle',
    logoUrl: 'flags/argentina.webp',
  },
  'Yue Yuan': {
    displayName: 'Yue Yuan',
    logoUrl: 'flags/china.webp',
  },
  'Carson Branstine': {
    displayName: 'Carson Branstine',
    logoUrl: 'flags/canada.webp',
  },
  'Daria Snigur': {
    displayName: 'Daria Snigur',
    logoUrl: 'flags/ukraine.webp',
  },
  'Chloe Paquet': {
    displayName: 'Chloe Paquet',
    logoUrl: 'flags/france.webp',
  },
  'Silvia Ambrosio': {
    displayName: 'Silvia Ambrosio',
    logoUrl: 'flags/italy.webp',
  },
  'Claire Liu': {
    displayName: 'Claire Liu',
    logoUrl: 'flags/united_states.webp',
  },
  'Maddison Inglis': {
    displayName: 'Maddison Inglis',
    logoUrl: 'flags/australia.webp',
  },
  'Iva Jovic': {
    displayName: 'Iva Jovic',
    logoUrl: 'flags/united_states.webp',
  },
  'Renata Zarazua': {
    displayName: 'Renata Zarazua',
    logoUrl: 'flags/mexico.webp',
  },
  'Tatjana Maria': {
    displayName: 'Tatjana Maria',
    logoUrl: 'flags/germany.webp',
  },
  'Marina Bassols Ribera': {
    displayName: 'Marina Bassols Ribera',
    logoUrl: 'flags/spain.webp',
  },
  'Iryna Shymanovich': {
    displayName: 'Iryna Shymanovich',
    logoUrl: 'flags/belarus.webp',
  },
  'Harriet Dart': {
    displayName: 'Harriet Dart',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Elena Pridankina': {
    displayName: 'Elena Pridankina',
    logoUrl: 'flags/russia.webp',
  },
  'Mai Hontama': {
    displayName: 'Mai Hontama',
    logoUrl: 'flags/japan.webp',
  },
  'Emma Navarro': {
    displayName: 'Emma Navarro',
    logoUrl: 'flags/united_states.webp',
  },
  'Antonia Ruzic': {
    displayName: 'Antonia Ruzic',
    logoUrl: 'flags/croatia.webp',
  },
  'Solana Sierra': {
    displayName: 'Solana Sierra',
    logoUrl: 'flags/argentina.webp',
  },
  'Peyton Stearns': {
    displayName: 'Peyton Stearns',
    logoUrl: 'flags/united_states.webp',
  },
  'Olga Danilovic': {
    displayName: 'Olga Danilovic',
    logoUrl: 'flags/serbia.webp',
  },
  'Ajla Tomljanovic': {
    displayName: 'Ajla Tomljanovic',
    logoUrl: 'flags/australia.webp',
  },
  'Alex Michelsen': {
    displayName: 'Alex Michelsen',
    logoUrl: 'flags/united_states.webp',
  },
  'Jakub Mensik': {
    displayName: 'Jakub Mensik',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Pablo Carreno Busta': {
    displayName: 'Pablo Carreno Busta',
    logoUrl: 'flags/spain.webp',
  },
  'Giovanni Mpetshi Perricard': {
    displayName: 'Giovanni Mpetshi Perricard',
    logoUrl: 'flags/france.webp',
  },
  'Gael Monfils': {
    displayName: 'Gael Monfils',
    logoUrl: 'flags/france.webp',
  },
  'Luca Nardi': {
    displayName: 'Luca Nardi',
    logoUrl: 'flags/italy.webp',
  },
  'Yibing Wu': {
    displayName: 'Yibing Wu',
    logoUrl: 'flags/china.webp',
  },
  'Hubert Hurkacz': {
    displayName: 'Hubert Hurkacz',
    logoUrl: 'flags/poland.webp',
  },
  'Zizou Bergs': {
    displayName: 'Zizou Bergs',
    logoUrl: 'flags/belgium.webp',
  },
  'Rafael Jodar': {
    displayName: 'Rafael Jodar',
    logoUrl: 'flags/spain.webp',
  },
  'Tomas Machac': {
    displayName: 'Tomas Machac',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Vit Kopriva': {
    displayName: 'Vit Kopriva',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Jan-Lennard Struff': {
    displayName: 'Jan-Lennard Struff',
    logoUrl: 'flags/germany.webp',
  },
  'Valentin Royer': {
    displayName: 'Valentin Royer',
    logoUrl: 'flags/france.webp',
  },
  'Jiri Lehecka': {
    displayName: 'Jiri Lehecka',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Jacob Fearnley': {
    displayName: 'Jacob Fearnley',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Taylor Fritz': {
    displayName: 'Taylor Fritz',
    logoUrl: 'flags/united_states.webp',
  },
  'Hugo Gaston': {
    displayName: 'Hugo Gaston',
    logoUrl: 'flags/france.webp',
  },
  'Shintaro Mochizuki': {
    displayName: 'Shintaro Mochizuki',
    logoUrl: 'flags/japan.webp',
  },
  'Frances Tiafoe': {
    displayName: 'Frances Tiafoe',
    logoUrl: 'flags/united_states.webp',
  },
  'Michael Zheng': {
    displayName: 'Michael Zheng',
    logoUrl: 'flags/united_states.webp',
  },
  'Carlos Alcaraz': {
    displayName: 'Carlos Alcaraz',
    logoUrl: 'flags/spain.webp',
  },
  'Quentin Halys': {
    displayName: 'Quentin Halys',
    logoUrl: 'flags/france.webp',
  },
  'Hamad Medjedovic': {
    displayName: 'Hamad Medjedovic',
    logoUrl: 'flags/serbia.webp',
  },
  'Thiago Agustin Tirante': {
    displayName: 'Thiago Agustin Tirante',
    logoUrl: 'flags/argentina.webp',
  },
  'Jordan Thompson': {
    displayName: 'Jordan Thompson',
    logoUrl: 'flags/australia.webp',
  },
  'Denis Shapovalov': {
    displayName: 'Denis Shapovalov',
    logoUrl: 'flags/canada.webp',
  },
  'Marin Cilic': {
    displayName: 'Marin Cilic',
    logoUrl: 'flags/croatia.webp',
  },
  'Botic Van de Zandschulp': {
    displayName: 'Botic Van de Zandschulp',
    logoUrl: 'flags/netherlands.webp',
  },
  'Juncheng Shang': {
    displayName: 'Juncheng Shang',
    logoUrl: 'flags/china.webp',
  },
  'Kamil Majchrzak': {
    displayName: 'Kamil Majchrzak',
    logoUrl: 'flags/poland.webp',
  },
  'Fabian Marozsan': {
    displayName: 'Fabian Marozsan',
    logoUrl: 'flags/hungary.webp',
  },
  'Rinky Hijikata': {
    displayName: 'Rinky Hijikata',
    logoUrl: 'flags/australia.webp',
  },
  'Arthur Gea': {
    displayName: 'Arthur Gea',
    logoUrl: 'flags/france.webp',
  },
  'Francesco Maestrelli': {
    displayName: 'Francesco Maestrelli',
    logoUrl: 'flags/italy.webp',
  },
  'Casper Ruud': {
    displayName: 'Casper Ruud',
    logoUrl: 'flags/norway.webp',
  },
  'Alexandre Muller': {
    displayName: 'Alexandre Muller',
    logoUrl: 'flags/france.webp',
  },
  'Julia Grabher': {
    displayName: 'Julia Grabher',
    logoUrl: 'flags/austria.webp',
  },
  'Karolina Pliskova': {
    displayName: 'Karolina Pliskova',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Lulu Sun': {
    displayName: 'Lulu Sun',
    logoUrl: 'flags/new_zealand.webp',
  },
  'Sonay Kartal': {
    displayName: 'Sonay Kartal',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Jelena Ostapenko': {
    displayName: 'Jelena Ostapenko',
    logoUrl: 'flags/latvia.webp',
  },
  'Eva Lys': {
    displayName: 'Eva Lys',
    logoUrl: 'flags/germany.webp',
  },
  'Laura Siegemund': {
    displayName: 'Laura Siegemund',
    logoUrl: 'flags/germany.webp',
  },
  'Liudmila Samsonova': {
    displayName: 'Liudmila Samsonova',
    logoUrl: 'flags/russia.webp',
  },
  'Naomi Osaka': {
    displayName: 'Naomi Osaka',
    logoUrl: 'flags/japan.webp',
  },
  'Elsa Jacquemot': {
    displayName: 'Elsa Jacquemot',
    logoUrl: 'flags/france.webp',
  },
  'Anastasia Potapova': {
    displayName: 'Anastasia Potapova',
    logoUrl: 'flags/russia.webp',
  },
  'Emma Raducanu': {
    displayName: 'Emma Raducanu',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Petra Marcinko': {
    displayName: 'Petra Marcinko',
    logoUrl: 'flags/croatia.webp',
  },
  'Hailey Baptiste': {
    displayName: 'Hailey Baptiste',
    logoUrl: 'flags/united_states.webp',
  },
  'Magdalena Frech': {
    displayName: 'Magdalena Frech',
    logoUrl: 'flags/poland.webp',
  },
  'McCartney Kessler': {
    displayName: 'McCartney Kessler',
    logoUrl: 'flags/united_states.webp',
  },
  'Polina Kudermetova': {
    displayName: 'Polina Kudermetova',
    logoUrl: 'flags/russia.webp',
  },
  'Clara Tauson': {
    displayName: 'Clara Tauson',
    logoUrl: 'flags/denmark.webp',
  },
  'Karolina Muchova': {
    displayName: 'Karolina Muchova',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Priscilla Hon': {
    displayName: 'Priscilla Hon',
    logoUrl: 'flags/australia.webp',
  },
  'Caty McNally': {
    displayName: 'Caty McNally',
    logoUrl: 'flags/united_states.webp',
  },
  'Paula Badosa': {
    displayName: 'Paula Badosa',
    logoUrl: 'flags/spain.webp',
  },
  'Elena-Gabriela Ruse': {
    displayName: 'Elena-Gabriela Ruse',
    logoUrl: 'flags/romania.webp',
  },
  'Maria Sakkari': {
    displayName: 'Maria Sakkari',
    logoUrl: 'flags/greece.webp',
  },
  'Mirra Andreeva': {
    displayName: 'Mirra Andreeva',
    logoUrl: 'flags/russia.webp',
  },
  'Marie Bouzkova': {
    displayName: 'Marie Bouzkova',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Elise Mertens': {
    displayName: 'Elise Mertens',
    logoUrl: 'flags/belgium.webp',
  },
  'Moyuka Uchijima': {
    displayName: 'Moyuka Uchijima',
    logoUrl: 'flags/japan.webp',
  },
  'Talia Gibson': {
    displayName: 'Talia Gibson',
    logoUrl: 'flags/australia.webp',
  },
  'Diana Shnaider': {
    displayName: 'Diana Shnaider',
    logoUrl: 'flags/russia.webp',
  },
  'Jan Choinski': {
    displayName: 'Jan Choinski',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Arthur Fils': {
    displayName: 'Arthur Fils',
    logoUrl: 'flags/france.webp',
  },
  'Andrea Vavassori': {
    displayName: 'Andrea Vavassori',
    logoUrl: 'flags/italy.webp',
  },
  'Ugo Blanchet': {
    displayName: 'Ugo Blanchet',
    logoUrl: 'flags/france.webp',
  },
  'Nikoloz Basilashvili': {
    displayName: 'Nikoloz Basilashvili',
    logoUrl: 'flags/georgia.webp',
  },
  'Moise Kouame': {
    displayName: 'Moise Kouame',
    logoUrl: 'flags/france.webp',
  },
  'Aleksandar Kovacevic': {
    displayName: 'Aleksandar Kovacevic',
    logoUrl: 'flags/united_states.webp',
  },
  'Oleksandra Oliynykova': {
    displayName: 'Oleksandra Oliynykova',
    logoUrl: 'flags/croatia.webp',
  },
  'Vendula Valdmannova': {
    displayName: 'Vendula Valdmannova',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Sara Sorribes Tormo': {
    displayName: 'Sara Sorribes Tormo',
    logoUrl: 'flags/spain.webp',
  },
  'Lucie Havlickova': {
    displayName: 'Lucie Havlickova',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Tiantsoa Sarah Rakotomanga Rajaonah': {
    displayName: 'Tiantsoa Sarah Rakotomanga Rajaonah',
    logoUrl: 'flags/france.webp',
  },
  'Sinja Kraus': {
    displayName: 'Sinja Kraus',
    logoUrl: 'flags/austria.webp',
  },
  'Simona Waltert': {
    displayName: 'Simona Waltert',
    logoUrl: 'flags/switzerland.webp',
  },
  'Tereza Martincova': {
    displayName: 'Tereza Martincova',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Elina Avanesyan': {
    displayName: 'Elina Avanesyan',
    logoUrl: 'flags/armenia.webp',
  },
  'Dayana Yastremska': {
    displayName: 'Dayana Yastremska',
    logoUrl: 'flags/ukraine.webp',
  },
  'Ekaterina Alexandrova': {
    displayName: 'Ekaterina Alexandrova',
    logoUrl: 'flags/russia.webp',
  },
  'Sara Bejlek': {
    displayName: 'Sara Bejlek',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Panna Udvardy': {
    displayName: 'Panna Udvardy',
    logoUrl: 'flags/hungary.webp',
  },
  'Roman Andres Burruchaga': {
    displayName: 'Roman Andres Burruchaga',
    logoUrl: 'flags/argentina.webp',
  },
  'Laslo Djere': {
    displayName: 'Laslo Djere',
    logoUrl: 'flags/serbia.webp',
  },
  'Facundo Diaz Acosta': {
    displayName: 'Facundo Diaz Acosta',
    logoUrl: 'flags/argentina.webp',
  },
  'Alejandro Tabilo': {
    displayName: 'Alejandro Tabilo',
    logoUrl: 'flags/chile.webp',
  },
  'Sho Shimabukuro': {
    displayName: 'Sho Shimabukuro',
    logoUrl: 'flags/japan.webp',
  },
  'Miomir Kecmanovic': {
    displayName: 'Miomir Kecmanovic',
    logoUrl: 'flags/serbia.webp',
  },
  'Francesco Passaro': {
    displayName: 'Francesco Passaro',
    logoUrl: 'flags/italy.webp',
  },
  'Flavio Cobolli': {
    displayName: 'Flavio Cobolli',
    logoUrl: 'flags/italy.webp',
  },
  'Jack Pinnington Jones': {
    displayName: 'Jack Pinnington Jones',
    logoUrl: 'flags/united-kingdom.webp',
  },
  'Federico Coria': {
    displayName: 'Federico Coria',
    logoUrl: 'flags/argentina.webp',
  },
  'Matteo Berrettini': {
    displayName: 'Matteo Berrettini',
    logoUrl: 'flags/italy.webp',
  },
  'Camilo Ugo Carabelli': {
    displayName: 'Camilo Ugo Carabelli',
    logoUrl: 'flags/argentina.webp',
  },
  'Francisco Comesana': {
    displayName: 'Francisco Comesana',
    logoUrl: 'flags/argentina.webp',
  },
  'Guy Den Ouden': {
    displayName: 'Guy Den Ouden',
    logoUrl: 'flags/netherlands.webp',
  },
  'Marton Fucsovics': {
    displayName: 'Marton Fucsovics',
    logoUrl: 'flags/hungary.webp',
  },
  'Karen Khachanov': {
    displayName: 'Karen Khachanov',
    logoUrl: 'flags/russia.webp',
  },
  'Jesper De Jong': {
    displayName: 'Jesper De Jong',
    logoUrl: 'flags/netherlands.webp',
  },
  'Stefanos Tsitsipas': {
    displayName: 'Stefanos Tsitsipas',
    logoUrl: 'flags/greece.webp',
  },
  'Arthur Rinderknech': {
    displayName: 'Arthur Rinderknech',
    logoUrl: 'flags/france.webp',
  },
  'Mariano Navone': {
    displayName: 'Mariano Navone',
    logoUrl: 'flags/argentina.webp',
  },
  'Francisco Cerundolo': {
    displayName: 'Francisco Cerundolo',
    logoUrl: 'flags/argentina.webp',
  },
  'Hugo Dellien': {
    displayName: 'Hugo Dellien',
    logoUrl: 'flags/bolivia.webp',
  },
  'Adam Walton': {
    displayName: 'Adam Walton',
    logoUrl: 'flags/australia.webp',
  },
  'Trevor Svajda': {
    displayName: 'Trevor Svajda',
    logoUrl: 'flags/united_states.webp',
  },
  'Alexei Popyrin': {
    displayName: 'Alexei Popyrin',
    logoUrl: 'flags/australia.webp',
  },
  'Felix Auger-Aliassime': {
    displayName: 'Felix Auger-Aliassime',
    logoUrl: 'flags/canada.webp',
  },
  'Zachary Svajda': {
    displayName: 'Zachary Svajda',
    logoUrl: 'flags/united_states.webp',
  },
  'Carlos Taberner': {
    displayName: 'Carlos Taberner',
    logoUrl: 'flags/spain.webp',
  },
  'Marcelo Tomas Barrios Vera': {
    displayName: 'Marcelo Tomas Barrios Vera',
    logoUrl: 'flags/chile.webp',
  },
  'Juan Manuel Cerundolo': {
    displayName: 'Juan Manuel Cerundolo',
    logoUrl: 'flags/argentina.webp',
  },
  'Thiago Monteiro': {
    displayName: 'Thiago Monteiro',
    logoUrl: 'flags/brazil.webp',
  },
  'Mattia Bellucci': {
    displayName: 'Mattia Bellucci',
    logoUrl: 'flags/italy.webp',
  },
  'Luis Guto Miguel': {
    displayName: 'Luis Guto Miguel',
    logoUrl: 'flags/brazil.webp',
  },
  'Vilius Gaubas': {
    displayName: 'Vilius Gaubas',
    logoUrl: 'flags/lithuania.webp',
  },
  'Terence Atmane': {
    displayName: 'Terence Atmane',
    logoUrl: 'flags/france.webp',
  },
  'Nicolas Jarry': {
    displayName: 'Nicolas Jarry',
    logoUrl: 'flags/chile.webp',
  },
  'Benjamin Bonzi': {
    displayName: 'Benjamin Bonzi',
    logoUrl: 'flags/france.webp',
  },
  'Martin Landaluce': {
    displayName: 'Martin Landaluce',
    logoUrl: 'flags/spain.webp',
  },
  'Federico Agustin Gomez': {
    displayName: 'Federico Agustin Gomez',
    logoUrl: 'flags/argentina.webp',
  },
  "Christopher O'Connell": {
    displayName: "Christopher O'Connell",
    logoUrl: 'flags/australia.webp',
  },
  'Billy Harris': {
    displayName: 'Billy Harris',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Darwin Blanch': {
    displayName: 'Darwin Blanch',
    logoUrl: 'flags/united_states.webp',
  },
  'Stefano Travaglia': {
    displayName: 'Stefano Travaglia',
    logoUrl: 'flags/italy.webp',
  },
  'Patrick Kypson': {
    displayName: 'Patrick Kypson',
    logoUrl: 'flags/united_states.webp',
  },
  'Andrew Johnson': {
    displayName: 'Andrew Johnson',
    logoUrl: 'flags/united_states.webp',
  },
  'Tristan Schoolkate': {
    displayName: 'Tristan Schoolkate',
    logoUrl: 'flags/australia.webp',
  },
  'Alex Bolt': {
    displayName: 'Alex Bolt',
    logoUrl: 'flags/australia.webp',
  },
  'Nicolas Mejia': {
    displayName: 'Nicolas Mejia',
    logoUrl: 'flags/colombia.webp',
  },
  'Chun Hsin Tseng': {
    displayName: 'Chun Hsin Tseng',
    logoUrl: 'flags/taiwan.webp',
  },
  'David Goffin': {
    displayName: 'David Goffin',
    logoUrl: 'flags/belgium.webp',
  },
  'Leandro Riedi': {
    displayName: 'Leandro Riedi',
    logoUrl: 'flags/switzerland.webp',
  },
  'Elias Ymer': {
    displayName: 'Elias Ymer',
    logoUrl: 'flags/sweden.webp',
  },
  'Coleman Wong': {
    displayName: 'Coleman Wong',
    logoUrl: 'flags/hong_kong.webp',
  },
  'Alexis Galarneau': {
    displayName: 'Alexis Galarneau',
    logoUrl: 'flags/canada.webp',
  },
  'Mitchell Krueger': {
    displayName: 'Mitchell Krueger',
    logoUrl: 'flags/united_states.webp',
  },
  'Ashlyn Krueger': {
    displayName: 'Ashlyn Krueger',
    logoUrl: 'flags/united_states.webp',
  },
  'Dalibor Svrcina': {
    displayName: 'Dalibor Svrcina',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Jagger Leach': {
    displayName: 'Jagger Leach',
    logoUrl: 'flags/united_states.webp',
  },
  'Mananchaya Sawangkaew': {
    displayName: 'Mananchaya Sawangkaew',
    logoUrl: 'flags/thailand.webp',
  },
  'Dalma Galfi': {
    displayName: 'Dalma Galfi',
    logoUrl: 'flags/hungary.webp',
  },
  'Akasha Urhobo': {
    displayName: 'Akasha Urhobo',
    logoUrl: 'flags/united_states.webp',
  },
  'Kamilla Rakhimova': {
    displayName: 'Kamilla Rakhimova',
    logoUrl: 'flags/russia.webp',
  },
  'Maria Timofeeva': {
    displayName: 'Maria Timofeeva',
    logoUrl: 'flags/russia.webp',
  },
  'Darja Semenistaja': {
    displayName: 'Darja Semenistaja',
    logoUrl: 'flags/latvia.webp',
  },
  'Kayla Day': {
    displayName: 'Kayla Day',
    logoUrl: 'flags/united_states.webp',
  },
  'Arthur Fery': {
    displayName: 'Arthur Fery',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Yunchaokete Bu': {
    displayName: 'Yunchaokete Bu',
    logoUrl: 'flags/china.webp',
  },
  'Ignacio Buse': {
    displayName: 'Ignacio Buse',
    logoUrl: 'flags/peru.webp',
  },
  'Liam Draxl': {
    displayName: 'Liam Draxl',
    logoUrl: 'flags/canada.webp',
  },
  'Jay Clarke': {
    displayName: 'Jay Clarke',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'James Duckworth': {
    displayName: 'James Duckworth',
    logoUrl: 'flags/australia.webp',
  },
  'Roberto Bautista Agut': {
    displayName: 'Roberto Bautista Agut',
    logoUrl: 'flags/spain.webp',
  },
  'Ethan Quinn': {
    displayName: 'Ethan Quinn',
    logoUrl: 'flags/united_states.webp',
  },
  'Matteo Arnaldi': {
    displayName: 'Matteo Arnaldi',
    logoUrl: 'flags/italy.webp',
  },
  'Alexander Shevchenko': {
    displayName: 'Alexander Shevchenko',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Dominic Stricker': {
    displayName: 'Dominic Stricker',
    logoUrl: 'flags/switzerland.webp',
  },
  'Juan Carlos Prado Angelo': {
    displayName: 'Juan Carlos Prado Angelo',
    logoUrl: 'flags/bolivia.webp',
  },
  'Raphael Collignon': {
    displayName: 'Raphael Collignon',
    logoUrl: 'flags/belgium.webp',
  },
  'Grigor Dimitrov': {
    displayName: 'Grigor Dimitrov',
    logoUrl: 'flags/bulgaria.webp',
  },
  'Zhizhen Zhang': {
    displayName: 'Zhizhen Zhang',
    logoUrl: 'flags/china.webp',
  },
  'Adrian Mannarino': {
    displayName: 'Adrian Mannarino',
    logoUrl: 'flags/france.webp',
  },
  'Emilio Nava': {
    displayName: 'Emilio Nava',
    logoUrl: 'flags/united_states.webp',
  },
  'Varvara Lepchenko': {
    displayName: 'Varvara Lepchenko',
    logoUrl: 'flags/united_states.webp',
  },
  'Linda Fruhvirtova': {
    displayName: 'Linda Fruhvirtova',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Katie Volynets': {
    displayName: 'Katie Volynets',
    logoUrl: 'flags/united_states.webp',
  },
  'Bianca Andreescu': {
    displayName: 'Bianca Andreescu',
    logoUrl: 'flags/canada.webp',
  },
  'Magda Linette': {
    displayName: 'Magda Linette',
    logoUrl: 'flags/poland.webp',
  },
  'Varvara Gracheva': {
    displayName: 'Varvara Gracheva',
    logoUrl: 'flags/france.webp',
  },
  'Ella Seidel': {
    displayName: 'Ella Seidel',
    logoUrl: 'flags/germany.webp',
  },
  'Rebeka Masarova': {
    displayName: 'Rebeka Masarova',
    logoUrl: 'flags/spain.webp',
  },
  'Katie Boulter': {
    displayName: 'Katie Boulter',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Jessica Bouzas Maneiro': {
    displayName: 'Jessica Bouzas Maneiro',
    logoUrl: 'flags/spain.webp',
  },
  'Sofia Kenin': {
    displayName: 'Sofia Kenin',
    logoUrl: 'flags/united_states.webp',
  },
  'Anna Blinkova': {
    displayName: 'Anna Blinkova',
    logoUrl: 'flags/russia.webp',
  },
  'Zeynep Sonmez': {
    displayName: 'Zeynep Sonmez',
    logoUrl: 'flags/turkey.webp',
  },
  'Beatriz Haddad Maia': {
    displayName: 'Beatriz Haddad Maia',
    logoUrl: 'flags/brazil.webp',
  },
  'Katerina Siniakova': {
    displayName: 'Katerina Siniakova',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Camila Osorio': {
    displayName: 'Camila Osorio',
    logoUrl: 'flags/colombia.webp',
  },
  'Emiliana Arango': {
    displayName: 'Emiliana Arango',
    logoUrl: 'flags/colombia.webp',
  },
  'Oksana Selekhmeteva': {
    displayName: 'Oksana Selekhmeteva',
    logoUrl: 'flags/russia.webp',
  },
  'Francesca Jones': {
    displayName: 'Francesca Jones',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Venus Williams': {
    displayName: 'Venus Williams',
    logoUrl: 'flags/united_states.webp',
  },
  'Jennifer Brady': {
    displayName: 'Jennifer Brady',
    logoUrl: 'flags/united_states.webp',
  },
  'Sloane Stephens': {
    displayName: 'Sloane Stephens',
    logoUrl: 'flags/united_states.webp',
  },
  'Tirante, Thiago Agustin': {
    displayName: 'Tirante, Thiago Agustin',
    logoUrl: 'flags/argentina.webp',
  },
  'Cadenasso, Gianluca': {
    displayName: 'Cadenasso, Gianluca',
    logoUrl: 'flags/italy.webp',
  },
  'Muller, Alexandre': {
    displayName: 'Muller, Alexandre',
    logoUrl: 'flags/france.webp',
  },
  'Van De Zandschulp, Botic': {
    displayName: 'Van De Zandschulp, Botic',
    logoUrl: 'flags/netherlands.webp',
  },
  'Cina, Federico': {
    displayName: 'Cina, Federico',
    logoUrl: 'flags/italy.webp',
  },
  'Blockx, Alexander': {
    displayName: 'Blockx, Alexander',
    logoUrl: 'flags/belgium.webp',
  },
  'Krejcikova, Barbora': {
    displayName: 'Krejcikova, Barbora',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Jacquemot, Elsa': {
    displayName: 'Jacquemot, Elsa',
    logoUrl: 'flags/france.webp',
  },
  'Siniakova, Katerina': {
    displayName: 'Siniakova, Katerina',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Boisson, Lois': {
    displayName: 'Boisson, Lois',
    logoUrl: 'flags/france.webp',
  },
  'Sonmez, Zeynep': {
    displayName: 'Sonmez, Zeynep',
    logoUrl: 'flags/turkey.webp',
  },
  'Ruggeri, Jennifer': {
    displayName: 'Ruggeri, Jennifer',
    logoUrl: 'flags/italy.webp',
  },
  'Trevisan, Martina': {
    displayName: 'Trevisan, Martina',
    logoUrl: 'flags/italy.webp',
  },
  'Gibson, Talia': {
    displayName: 'Gibson, Talia',
    logoUrl: 'flags/australia.webp',
  },
  'Pigato, Lisa': {
    displayName: 'Pigato, Lisa',
    logoUrl: 'flags/italy.webp',
  },
  'Grant, Tyra Caterina': {
    displayName: 'Grant, Tyra Caterina',
    logoUrl: 'flags/united_states.webp',
  },
  'G Mpetshi Perricard': {
    displayName: 'G Mpetshi Perricard',
    logoUrl: 'flags/france.webp',
  },
  'Justin Engel': {
    displayName: 'Justin Engel',
    logoUrl: 'flags/germany.webp',
  },
  'A Davidovich Fokina': {
    displayName: 'A Davidovich Fokina',
    logoUrl: 'flags/spain.webp',
  },
  'Alex De Minaur': {
    displayName: 'Alex De Minaur',
    logoUrl: 'flags/australia.webp',
  },
  'Edas Butvilas': {
    displayName: 'Edas Butvilas',
    logoUrl: 'flags/lithuania.webp',
  },
  'Clement Tabur': {
    displayName: 'Clement Tabur',
    logoUrl: 'flags/france.webp',
  },
  'Hanne Vandewinkel': {
    displayName: 'Hanne Vandewinkel',
    logoUrl: 'flags/belgium.webp',
  },
  'Jil Teichmann': {
    displayName: 'Jil Teichmann',
    logoUrl: 'flags/switzerland.webp',
  },
  'Sada Nahimana': {
    displayName: 'Sada Nahimana',
    logoUrl: 'flags/burundi.webp',
  },
  'Angela Fita Boluda': {
    displayName: 'Angela Fita Boluda',
    logoUrl: 'flags/spain.webp',
  },
  'Yasmine Kabbaj': {
    displayName: 'Yasmine Kabbaj',
    logoUrl: 'flags/morocco.webp',
  },
  'Berfu Cengiz': {
    displayName: 'Berfu Cengiz',
    logoUrl: 'flags/turkey.webp',
  },
  'D El Jardi': {
    displayName: 'D El Jardi',
    logoUrl: 'flags/morocco.webp',
  },
  'Yelyzaveta Kotliar': {
    displayName: 'Yelyzaveta Kotliar',
    logoUrl: 'flags/ukraine.webp',
  },
  'Polona Hercog': {
    displayName: 'Polona Hercog',
    logoUrl: 'flags/slovenia.webp',
  },
  'Lois Boisson': {
    displayName: 'Lois Boisson',
    logoUrl: 'flags/france.webp',
  },
  'Nick Kyrgios': {
    displayName: 'Nick Kyrgios',
    logoUrl: 'flags/australia.webp',
  },
  'Diego Dedura': {
    displayName: 'Diego Dedura',
    logoUrl: 'flags/germany.webp',
  },
  'Tom Gentzsch': {
    displayName: 'Tom Gentzsch',
    logoUrl: 'flags/germany.webp',
  },
  'Otto Virtanen': {
    displayName: 'Otto Virtanen',
    logoUrl: 'flags/finland.webp',
  },
  'Thijs Boogaard': {
    displayName: 'Thijs Boogaard',
    logoUrl: 'flags/netherlands.webp',
  },
  'Botic van de Zandschulp': {
    displayName: 'Botic van de Zandschulp',
    logoUrl: 'flags/netherlands.webp',
  },
  'Elena Ruse': {
    displayName: 'Elena Ruse',
    logoUrl: 'flags/romania.webp',
  },
  'Barbora Krejcikova': {
    displayName: 'Barbora Krejcikova',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Suzan Lamens': {
    displayName: 'Suzan Lamens',
    logoUrl: 'flags/netherlands.webp',
  },
  'Leylah Fernandez': {
    displayName: 'Leylah Fernandez',
    logoUrl: 'flags/canada.webp',
  },
  'Mika Stojsavljevic': {
    displayName: 'Mika Stojsavljevic',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Musetti, Lorenzo': {
    displayName: 'Musetti, Lorenzo',
    logoUrl: 'flags/italy.webp',
  },
  'Sonego, Lorenzo': {
    displayName: 'Sonego, Lorenzo',
    logoUrl: 'flags/italy.webp',
  },
  'Moutet, Corentin': {
    displayName: 'Moutet, Corentin',
    logoUrl: 'flags/france.webp',
  },
  'Diallo, Gabriel': {
    displayName: 'Diallo, Gabriel',
    logoUrl: 'flags/canada.webp',
  },
  'de Minaur, Alex': {
    displayName: 'de Minaur, Alex',
    logoUrl: 'flags/australia.webp',
  },
  'Khachanov, Karen': {
    displayName: 'Khachanov, Karen',
    logoUrl: 'flags/russia.webp',
  },
  'Fonseca, Joao': {
    displayName: 'Fonseca, Joao',
    logoUrl: 'flags/brazil.webp',
  },
  'Dimitrov, Grigor': {
    displayName: 'Dimitrov, Grigor',
    logoUrl: 'flags/bulgaria.webp',
  },
  'Medvedev, Daniil': {
    displayName: 'Medvedev, Daniil',
    logoUrl: 'flags/russia.webp',
  },
  'Shelton, Ben': {
    displayName: 'Shelton, Ben',
    logoUrl: 'flags/united_states.webp',
  },
  'Rublev, Andrey': {
    displayName: 'Rublev, Andrey',
    logoUrl: 'flags/russia.webp',
  },
  'Norrie, Cameron': {
    displayName: 'Norrie, Cameron',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Vacherot, Valentin': {
    displayName: 'Vacherot, Valentin',
    logoUrl: 'flags/monaco.webp',
  },
  'Parks, Alycia': {
    displayName: 'Parks, Alycia',
    logoUrl: 'flags/united_states.webp',
  },
  'Juvan, Kaja': {
    displayName: 'Juvan, Kaja',
    logoUrl: 'flags/slovenia.webp',
  },
  'Salkova, Dominika': {
    displayName: 'Salkova, Dominika',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Zakharova, Anastasia': {
    displayName: 'Zakharova, Anastasia',
    logoUrl: 'flags/russia.webp',
  },
  'Blinkova, Anna': {
    displayName: 'Blinkova, Anna',
    logoUrl: 'flags/russia.webp',
  },
  'Bondar, Anna': {
    displayName: 'Bondar, Anna',
    logoUrl: 'flags/hungary.webp',
  },
  'Kalinskaya, Anna': {
    displayName: 'Kalinskaya, Anna',
    logoUrl: 'flags/russia.webp',
  },
  'Zhang, Shuai': {
    displayName: 'Zhang, Shuai',
    logoUrl: 'flags/china.webp',
  },
  'Bencic, Belinda': {
    displayName: 'Bencic, Belinda',
    logoUrl: 'flags/switzerland.webp',
  },
  'Wang, Yafan': {
    displayName: 'Wang, Yafan',
    logoUrl: 'flags/china.webp',
  },
  'Rodionova, Arina': {
    displayName: 'Rodionova, Arina',
    logoUrl: 'flags/australia.webp',
  },
  'Hunter, Storm': {
    displayName: 'Hunter, Storm',
    logoUrl: 'flags/australia.webp',
  },
  'Bai, Zhuoxuan': {
    displayName: 'Bai, Zhuoxuan',
    logoUrl: 'flags/china.webp',
  },
  'Guo, Hanyu': {
    displayName: 'Guo, Hanyu',
    logoUrl: 'flags/china.webp',
  },
  'Tjen, Janice': {
    displayName: 'Tjen, Janice',
    logoUrl: 'flags/indonesia.webp',
  },
  'Fruhvirtova, Linda': {
    displayName: 'Fruhvirtova, Linda',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Eala, Alexandra': {
    displayName: 'Eala, Alexandra',
    logoUrl: 'flags/philippines.webp',
  },
  'Mboko, Victoria': {
    displayName: 'Mboko, Victoria',
    logoUrl: 'flags/canada.webp',
  },
  'Garland, Joanna': {
    displayName: 'Garland, Joanna',
    logoUrl: 'flags/taiwan.webp',
  },
  'Yamaguchi, Mei': {
    displayName: 'Yamaguchi, Mei',
    logoUrl: 'flags/japan.webp',
  },
  'Sakatsume, Himeno': {
    displayName: 'Sakatsume, Himeno',
    logoUrl: 'flags/japan.webp',
  },
  'Chong, Eudice': {
    displayName: 'Chong, Eudice',
    logoUrl: 'flags/hong_kong.webp',
  },
  'Birrell, Kimberly': {
    displayName: 'Birrell, Kimberly',
    logoUrl: 'flags/australia.webp',
  },
  'Bhamidipaty, Shrivalli': {
    displayName: 'Bhamidipaty, Shrivalli',
    logoUrl: 'flags/india.webp',
  },
  'Tagger, Lilli': {
    displayName: 'Tagger, Lilli',
    logoUrl: 'flags/austria.webp',
  },
  'Korpatsch, Tamara': {
    displayName: 'Korpatsch, Tamara',
    logoUrl: 'flags/germany.webp',
  },
  'Putintseva, Yuliya': {
    displayName: 'Putintseva, Yuliya',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Golubic, Viktorija': {
    displayName: 'Golubic, Viktorija',
    logoUrl: 'flags/switzerland.webp',
  },
  'Cerundolo, Francisco': {
    displayName: 'Cerundolo, Francisco',
    logoUrl: 'flags/argentina.webp',
  },
  'Sinner, Jannik': {
    displayName: 'Sinner, Jannik',
    logoUrl: 'flags/italy.webp',
  },
  'Davidovich Fokina, Alejandro': {
    displayName: 'Davidovich Fokina, Alejandro',
    logoUrl: 'flags/spain.webp',
  },
  'Zverev, Alexander': {
    displayName: 'Zverev, Alexander',
    logoUrl: 'flags/germany.webp',
  },
  'Tararudee, Lanlana': {
    displayName: 'Tararudee, Lanlana',
    logoUrl: 'flags/thailand.webp',
  },
  'Pohankova, Mia': {
    displayName: 'Pohankova, Mia',
    logoUrl: 'flags/slovakia.webp',
  },
  'Parry, Diane': {
    displayName: 'Parry, Diane',
    logoUrl: 'flags/france.webp',
  },
  'Bucsa, Cristina': {
    displayName: 'Bucsa, Cristina',
    logoUrl: 'flags/spain.webp',
  },
  'Fernandez, Leylah Annie': {
    displayName: 'Fernandez, Leylah Annie',
    logoUrl: 'flags/canada.webp',
  },
  'Cirstea, Sorana': {
    displayName: 'Cirstea, Sorana',
    logoUrl: 'flags/romania.webp',
  },
  'Putintseva, Yulia': {
    displayName: 'Putintseva, Yulia',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Jacquet, Kyrian': {
    displayName: 'Jacquet, Kyrian',
    logoUrl: 'flags/france.webp',
  },
  'Van Assche, Luca': {
    displayName: 'Van Assche, Luca',
    logoUrl: 'flags/france.webp',
  },
  'McDonald, Mackenzie': {
    displayName: 'McDonald, Mackenzie',
    logoUrl: 'flags/united_states.webp',
  },
  'Etcheverry, Tomas Martin': {
    displayName: 'Etcheverry, Tomas Martin',
    logoUrl: 'flags/argentina.webp',
  },
  'Passaro, Francesco': {
    displayName: 'Passaro, Francesco',
    logoUrl: 'flags/italy.webp',
  },
  'Altmaier, Daniel': {
    displayName: 'Altmaier, Daniel',
    logoUrl: 'flags/germany.webp',
  },
  'Rinderknech, Arthur': {
    displayName: 'Rinderknech, Arthur',
    logoUrl: 'flags/france.webp',
  },
  'Hanfmann, Yannick': {
    displayName: 'Hanfmann, Yannick',
    logoUrl: 'flags/germany.webp',
  },
  'Ivanov, Ivan': {
    displayName: 'Ivanov, Ivan',
    logoUrl: 'flags/bulgaria.webp',
  },
  'Korda, Sebastian': {
    displayName: 'Korda, Sebastian',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Dzumhur, Damir': {
    displayName: 'Dzumhur, Damir',
    logoUrl: 'flags/bosnia_and_herzegovina.webp',
  },
  'Vukic, Aleksandar': {
    displayName: 'Vukic, Aleksandar',
    logoUrl: 'flags/australia.webp',
  },
  'Giron, Marcos': {
    displayName: 'Giron, Marcos',
    logoUrl: 'flags/united_states.webp',
  },
  'Martinez, Pedro': {
    displayName: 'Martinez, Pedro',
    logoUrl: 'flags/dominican_republic.webp',
  },
  'Djokovic, Novak': {
    displayName: 'Djokovic, Novak',
    logoUrl: 'flags/serbia.webp',
  },
  'Tabilo, Alejandro': {
    displayName: 'Tabilo, Alejandro',
    logoUrl: 'flags/chile.webp',
  },
  'Cobolli, Flavio': {
    displayName: 'Cobolli, Flavio',
    logoUrl: 'flags/italy.webp',
  },
  'Spizzirri, Eliot': {
    displayName: 'Spizzirri, Eliot',
    logoUrl: 'flags/united_states.webp',
  },
  'Borges, Nuno': {
    displayName: 'Borges, Nuno',
    logoUrl: 'flags/portugal.webp',
  },
  'Cazaux, Arthur': {
    displayName: 'Cazaux, Arthur',
    logoUrl: 'flags/france.webp',
  },
  'Sachko, Vitaliy': {
    displayName: 'Sachko, Vitaliy',
    logoUrl: 'flags/ukraine.webp',
  },
  'Bublik, Alexander': {
    displayName: 'Bublik, Alexander',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Tien, Learner': {
    displayName: 'Tien, Learner',
    logoUrl: 'flags/united_states.webp',
  },
  'Echargui, Moez': {
    displayName: 'Echargui, Moez',
    logoUrl: 'flags/tunisia.webp',
  },
  'Kecmanovic, Miomir': {
    displayName: 'Kecmanovic, Miomir',
    logoUrl: 'flags/serbia.webp',
  },
  'Darderi, Luciano': {
    displayName: 'Darderi, Luciano',
    logoUrl: 'flags/italy.webp',
  },
  'Wawrinka, Stan': {
    displayName: 'Wawrinka, Stan',
    logoUrl: 'flags/switzerland.webp',
  },
  'Gauff, Coco': {
    displayName: 'Gauff, Coco',
    logoUrl: 'flags/united_states.webp',
  },
  'Paolini, Jasmine': {
    displayName: 'Paolini, Jasmine',
    logoUrl: 'flags/italy.webp',
  },
  'Sabalenka, Aryna': {
    displayName: 'Sabalenka, Aryna',
    logoUrl: 'flags/belarus.webp',
  },
  'Pegula, Jessica': {
    displayName: 'Pegula, Jessica',
    logoUrl: 'flags/united_states.webp',
  },
  'Rybakina, Elena': {
    displayName: 'Rybakina, Elena',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Keys, Madison': {
    displayName: 'Keys, Madison',
    logoUrl: 'flags/united_states.webp',
  },
  'Swiatek, Iga': {
    displayName: 'Swiatek, Iga',
    logoUrl: 'flags/poland.webp',
  },
  'Anisimova, Amanda': {
    displayName: 'Anisimova, Amanda',
    logoUrl: 'flags/united_states.webp',
  },
  'Auger-Aliassime, Felix': {
    displayName: 'Auger-Aliassime, Felix',
    logoUrl: 'flags/canada.webp',
  },
  'Joint, Maya': {
    displayName: 'Joint, Maya',
    logoUrl: 'flags/australia.webp',
  },
  'Vekic, Donna': {
    displayName: 'Vekic, Donna',
    logoUrl: 'flags/croatia.webp',
  },
  'Iatcenko, Polina': {
    displayName: 'Iatcenko, Polina',
    logoUrl: 'flags/russia.webp',
  },
  'Nakashima, Brandon': {
    displayName: 'Nakashima, Brandon',
    logoUrl: 'flags/united_states.webp',
  },
  'Svitolina, Elina': {
    displayName: 'Svitolina, Elina',
    logoUrl: 'flags/ukraine.webp',
  },
  'Wang, Xinyu': {
    displayName: 'Wang, Xinyu',
    logoUrl: 'flags/china.webp',
  },
  'Kostyuk, Marta': {
    displayName: 'Kostyuk, Marta',
    logoUrl: 'flags/ukraine.webp',
  },
  'Comesana, Francisco': {
    displayName: 'Comesana, Francisco',
    logoUrl: 'flags/argentina.webp',
  },
  'Boyer, Tristan': {
    displayName: 'Boyer, Tristan',
    logoUrl: 'flags/united_states.webp',
  },
  'Bueno, Gonzalo': {
    displayName: 'Bueno, Gonzalo',
    logoUrl: 'flags/peru.webp',
  },
  'Herbert, Pierre-Hugues': {
    displayName: 'Herbert, Pierre-Hugues',
    logoUrl: 'flags/france.webp',
  },
  'Hassan, Benjamin': {
    displayName: 'Hassan, Benjamin',
    logoUrl: 'flags/lebanon.webp',
  },
  'Faria, Jaime': {
    displayName: 'Faria, Jaime',
    logoUrl: 'flags/portugal.webp',
  },
  'Sakamoto, Rei': {
    displayName: 'Sakamoto, Rei',
    logoUrl: 'flags/japan.webp',
  },
  'Smith, Colton': {
    displayName: 'Smith, Colton',
    logoUrl: 'flags/united_states.webp',
  },
  'Holt, Brandon': {
    displayName: 'Holt, Brandon',
    logoUrl: 'flags/united_states.webp',
  },
  'Zeppieri, Giulio': {
    displayName: 'Zeppieri, Giulio',
    logoUrl: 'flags/italy.webp',
  },
  'Prizmic, Dino': {
    displayName: 'Prizmic, Dino',
    logoUrl: 'flags/croatia.webp',
  },
  'Heide, Gustavo': {
    displayName: 'Heide, Gustavo',
    logoUrl: 'flags/brazil.webp',
  },
  'Rocha, Henrique': {
    displayName: 'Rocha, Henrique',
    logoUrl: 'flags/portugal.webp',
  },
  'Trungelliti, Marco': {
    displayName: 'Trungelliti, Marco',
    logoUrl: 'flags/argentina.webp',
  },
  'Nishioka, Yoshihito': {
    displayName: 'Nishioka, Yoshihito',
    logoUrl: 'flags/japan.webp',
  },
  'Loffhagen, George': {
    displayName: 'Loffhagen, George',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Kym, Jerome': {
    displayName: 'Kym, Jerome',
    logoUrl: 'flags/switzerland.webp',
  },
  'Sweeny, Dane': {
    displayName: 'Sweeny, Dane',
    logoUrl: 'flags/australia.webp',
  },
  'Damm Jr, Martin': {
    displayName: 'Damm Jr, Martin',
    logoUrl: 'flags/united_states.webp',
  },
  'Droguet, Titouan': {
    displayName: 'Droguet, Titouan',
    logoUrl: 'flags/france.webp',
  },
  'Carballes Baena, Roberto': {
    displayName: 'Carballes Baena, Roberto',
    logoUrl: 'flags/spain.webp',
  },
  'Arnaud Bailly, Gilles': {
    displayName: 'Arnaud Bailly, Gilles',
    logoUrl: 'flags/belgium.webp',
  },
  'Basavareddy, Nishesh': {
    displayName: 'Basavareddy, Nishesh',
    logoUrl: 'flags/united_states.webp',
  },
  'Ofner, Sebastian': {
    displayName: 'Ofner, Sebastian',
    logoUrl: 'flags/austria.webp',
  },
  'Lajovic, Dusan': {
    displayName: 'Lajovic, Dusan',
    logoUrl: 'flags/serbia.webp',
  },
  'Cassone, Murphy': {
    displayName: 'Cassone, Murphy',
    logoUrl: 'flags/united_states.webp',
  },
  'Glinka, Daniil': {
    displayName: 'Glinka, Daniil',
    logoUrl: 'flags/estonia.webp',
  },
  'Merida, Daniel': {
    displayName: 'Merida, Daniel',
    logoUrl: 'flags/spain.webp',
  },
  'Klein, Lukas': {
    displayName: 'Klein, Lukas',
    logoUrl: 'flags/slovakia.webp',
  },
  'Fery, Arthur': {
    displayName: 'Fery, Arthur',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Tomic, Bernard': {
    displayName: 'Tomic, Bernard',
    logoUrl: 'flags/australia.webp',
  },
  'Brooksby, Jenson': {
    displayName: 'Brooksby, Jenson',
    logoUrl: 'flags/united_states.webp',
  },
  'Baez, Sebastian': {
    displayName: 'Baez, Sebastian',
    logoUrl: 'flags/argentina.webp',
  },
  'Opelka, Reilly': {
    displayName: 'Opelka, Reilly',
    logoUrl: 'flags/united_states.webp',
  },
  'Paul, Tommy': {
    displayName: 'Paul, Tommy',
    logoUrl: 'flags/united_states.webp',
  },
  'Munar, Jaume': {
    displayName: 'Munar, Jaume',
    logoUrl: 'flags/spain.webp',
  },
  'Kokkinakis, Thanasi': {
    displayName: 'Kokkinakis, Thanasi',
    logoUrl: 'flags/australia.webp',
  },
  'Griekspoor, Tallon': {
    displayName: 'Griekspoor, Tallon',
    logoUrl: 'flags/netherlands.webp',
  },
  'Humbert, Ugo': {
    displayName: 'Humbert, Ugo',
    logoUrl: 'flags/france.webp',
  },
  'Starodubtseva, Yuliia': {
    displayName: 'Starodubtseva, Yuliia',
    logoUrl: 'flags/ukraine.webp',
  },
  'Papamichail, Despina': {
    displayName: 'Papamichail, Despina',
    logoUrl: 'flags/greece.webp',
  },
  'Riera, Julia': {
    displayName: 'Riera, Julia',
    logoUrl: 'flags/argentina.webp',
  },
  'Hruncakova, Viktoria': {
    displayName: 'Hruncakova, Viktoria',
    logoUrl: 'flags/slovakia.webp',
  },
  'Tomova, Viktoriya': {
    displayName: 'Tomova, Viktoriya',
    logoUrl: 'flags/bulgaria.webp',
  },
  'Bronzetti, Lucia': {
    displayName: 'Bronzetti, Lucia',
    logoUrl: 'flags/italy.webp',
  },
  'Stoiana, Mary': {
    displayName: 'Stoiana, Mary',
    logoUrl: 'flags/united_states.webp',
  },
  'Maristany Zuleta de Reales, Guiomar': {
    displayName: 'Maristany Zuleta de Reales, Guiomar',
    logoUrl: 'flags/spain.webp',
  },
  'Prozorova, Tatiana': {
    displayName: 'Prozorova, Tatiana',
    logoUrl: 'flags/russia.webp',
  },
  'Mikulskyte, Justina': {
    displayName: 'Mikulskyte, Justina',
    logoUrl: 'flags/lithuania.webp',
  },
  'Gasanova, Anastasia': {
    displayName: 'Gasanova, Anastasia',
    logoUrl: 'flags/russia.webp',
  },
  'Kalieva, Elvina': {
    displayName: 'Kalieva, Elvina',
    logoUrl: 'flags/united_states.webp',
  },
  'MA, Yexin': {
    displayName: 'MA, Yexin',
    logoUrl: 'flags/china.webp',
  },
  'Cocciaretto, Elisabetta': {
    displayName: 'Cocciaretto, Elisabetta',
    logoUrl: 'flags/italy.webp',
  },
  'Li, Ann': {
    displayName: 'Li, Ann',
    logoUrl: 'flags/united_states.webp',
  },
  'Stephens, Sloane': {
    displayName: 'Stephens, Sloane',
    logoUrl: 'flags/united_states.webp',
  },
  'Gadecki, Olivia': {
    displayName: 'Gadecki, Olivia',
    logoUrl: 'flags/australia.webp',
  },
  'Cabrera, Lizette': {
    displayName: 'Cabrera, Lizette',
    logoUrl: 'flags/australia.webp',
  },
  'Klimovicova, Linda': {
    displayName: 'Klimovicova, Linda',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Masarova, Rebeka': {
    displayName: 'Masarova, Rebeka',
    logoUrl: 'flags/spain.webp',
  },
  'Chwalinska, Maja': {
    displayName: 'Chwalinska, Maja',
    logoUrl: 'flags/poland.webp',
  },
  'Ferro, Fiona': {
    displayName: 'Ferro, Fiona',
    logoUrl: 'flags/france.webp',
  },
  'Koevermans, Anouk': {
    displayName: 'Koevermans, Anouk',
    logoUrl: 'flags/netherlands.webp',
  },
  'Kalinina, Anhelina': {
    displayName: 'Kalinina, Anhelina',
    logoUrl: 'flags/ukraine.webp',
  },
  'Minnen, Greet': {
    displayName: 'Minnen, Greet',
    logoUrl: 'flags/belgium.webp',
  },
  'Tan, Harmony': {
    displayName: 'Tan, Harmony',
    logoUrl: 'flags/france.webp',
  },
  'Lee, Carol Young Suh': {
    displayName: 'Lee, Carol Young Suh',
    logoUrl: 'flags/northern_mariana_islands.webp',
  },
  'Micic, Elena': {
    displayName: 'Micic, Elena',
    logoUrl: 'flags/australia.webp',
  },
  'Kasatkina, Daria': {
    displayName: 'Kasatkina, Daria',
    logoUrl: 'flags/russia.webp',
  },
  'Cristian, Jaqueline': {
    displayName: 'Cristian, Jaqueline',
    logoUrl: 'flags/romania.webp',
  },
  'Vondrousova, Marketa': {
    displayName: 'Vondrousova, Marketa',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Sramkova, Rebecca': {
    displayName: 'Sramkova, Rebecca',
    logoUrl: 'flags/slovakia.webp',
  },
  'Preston, Taylah': {
    displayName: 'Preston, Taylah',
    logoUrl: 'flags/australia.webp',
  },
  'Jimenez Kasintseva, Victoria': {
    displayName: 'Jimenez Kasintseva, Victoria',
    logoUrl: 'flags/andorra.webp',
  },
  'Zhu, Lin': {
    displayName: 'Zhu, Lin',
    logoUrl: 'flags/china.webp',
  },
  'Bartunkova, Nikola': {
    displayName: 'Bartunkova, Nikola',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Smith, Tina Nadine': {
    displayName: 'Smith, Tina Nadine',
    logoUrl: 'flags/australia.webp',
  },
  'Kostovic, Teodora': {
    displayName: 'Kostovic, Teodora',
    logoUrl: 'flags/serbia.webp',
  },
  'Stakusic, Marina': {
    displayName: 'Stakusic, Marina',
    logoUrl: 'flags/canada.webp',
  },
  'Townsend, Taylor': {
    displayName: 'Townsend, Taylor',
    logoUrl: 'flags/united_states.webp',
  },
  'Ortenzi, Jazmin': {
    displayName: 'Ortenzi, Jazmin',
    logoUrl: 'flags/argentina.webp',
  },
  'Osuigwe, Whitney': {
    displayName: 'Osuigwe, Whitney',
    logoUrl: 'flags/united_states.webp',
  },
  'Stefanini, Lucrezia': {
    displayName: 'Stefanini, Lucrezia',
    logoUrl: 'flags/italy.webp',
  },
  'Valentova, Tereza': {
    displayName: 'Valentova, Tereza',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Selekhmeteva, Oksana': {
    displayName: 'Selekhmeteva, Oksana',
    logoUrl: 'flags/russia.webp',
  },
  'Linette, Magda': {
    displayName: 'Linette, Magda',
    logoUrl: 'flags/poland.webp',
  },
  'Radivojevic, Lola': {
    displayName: 'Radivojevic, Lola',
    logoUrl: 'flags/serbia.webp',
  },
  'Sasnovich, Aliaksandra': {
    displayName: 'Sasnovich, Aliaksandra',
    logoUrl: 'flags/belarus.webp',
  },
  'Von Deichmann, Kathinka': {
    displayName: 'Von Deichmann, Kathinka',
    logoUrl: 'flags/liechtenstein.webp',
  },
  'Gjorcheska, Lina': {
    displayName: 'Gjorcheska, Lina',
    logoUrl: 'flags/north_macedonia.webp',
  },
  'Zidansek, Tamara': {
    displayName: 'Zidansek, Tamara',
    logoUrl: 'flags/slovenia.webp',
  },
  'Vidmanova, Darja': {
    displayName: 'Vidmanova, Darja',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Carle, Maria': {
    displayName: 'Carle, Maria',
    logoUrl: 'flags/argentina.webp',
  },
  'Yuan, Yue': {
    displayName: 'Yuan, Yue',
    logoUrl: 'flags/china.webp',
  },
  'Branstine, Carson': {
    displayName: 'Branstine, Carson',
    logoUrl: 'flags/canada.webp',
  },
  'Snigur, Daria': {
    displayName: 'Snigur, Daria',
    logoUrl: 'flags/ukraine.webp',
  },
  'Paquet, Chloe': {
    displayName: 'Paquet, Chloe',
    logoUrl: 'flags/france.webp',
  },
  'Ambrosio, Silvia': {
    displayName: 'Ambrosio, Silvia',
    logoUrl: 'flags/italy.webp',
  },
  'Liu, Claire': {
    displayName: 'Liu, Claire',
    logoUrl: 'flags/united_states.webp',
  },
  'Inglis, Maddison': {
    displayName: 'Inglis, Maddison',
    logoUrl: 'flags/australia.webp',
  },
  'Jovic, Iva': {
    displayName: 'Jovic, Iva',
    logoUrl: 'flags/united_states.webp',
  },
  'Zarazua, Renata': {
    displayName: 'Zarazua, Renata',
    logoUrl: 'flags/mexico.webp',
  },
  'Maria, Tatjana': {
    displayName: 'Maria, Tatjana',
    logoUrl: 'flags/germany.webp',
  },
  'Bassols Ribera, Marina': {
    displayName: 'Bassols Ribera, Marina',
    logoUrl: 'flags/spain.webp',
  },
  'Shymanovich, Iryna': {
    displayName: 'Shymanovich, Iryna',
    logoUrl: 'flags/belarus.webp',
  },
  'Dart, Harriet': {
    displayName: 'Dart, Harriet',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Pridankina, Elena': {
    displayName: 'Pridankina, Elena',
    logoUrl: 'flags/russia.webp',
  },
  'Hontama, Mai': {
    displayName: 'Hontama, Mai',
    logoUrl: 'flags/japan.webp',
  },
  'Shnaider, Diana': {
    displayName: 'Shnaider, Diana',
    logoUrl: 'flags/russia.webp',
  },
  'Navarro, Emma': {
    displayName: 'Navarro, Emma',
    logoUrl: 'flags/united_states.webp',
  },
  'Ruzic, Antonia': {
    displayName: 'Ruzic, Antonia',
    logoUrl: 'flags/croatia.webp',
  },
  'Sierra, Solana': {
    displayName: 'Sierra, Solana',
    logoUrl: 'flags/argentina.webp',
  },
  'Stearns, Peyton': {
    displayName: 'Stearns, Peyton',
    logoUrl: 'flags/united_states.webp',
  },
  'Danilovic, Olga': {
    displayName: 'Danilovic, Olga',
    logoUrl: 'flags/serbia.webp',
  },
  'Tomljanovic, Ajla': {
    displayName: 'Tomljanovic, Ajla',
    logoUrl: 'flags/australia.webp',
  },
  'Quinn, Ethan': {
    displayName: 'Quinn, Ethan',
    logoUrl: 'flags/usa.webp',
  },
  'O\'Connell, Christopher': {
    displayName: 'O\'Connell, Christopher',
    logoUrl: 'flags/australia.webp',
  },
  'Michelsen, Alex': {
    displayName: 'Michelsen, Alex',
    logoUrl: 'flags/united_states.webp',
  },
  'Mensik, Jakub': {
    displayName: 'Mensik, Jakub',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Carreno Busta, Pablo': {
    displayName: 'Carreno Busta, Pablo',
    logoUrl: 'flags/spain.webp',
  },
  'Mpetshi Perricard, Giovanni': {
    displayName: 'Mpetshi Perricard, Giovanni',
    logoUrl: 'flags/france.webp',
  },
  'Monfils, Gael': {
    displayName: 'Monfils, Gael',
    logoUrl: 'flags/france.webp',
  },
  'Nardi, Luca': {
    displayName: 'Nardi, Luca',
    logoUrl: 'flags/italy.webp',
  },
  'Wu, Yibing': {
    displayName: 'Wu, Yibing',
    logoUrl: 'flags/china.webp',
  },
  'Hurkacz, Hubert': {
    displayName: 'Hurkacz, Hubert',
    logoUrl: 'flags/poland.webp',
  },
  'Bergs, Zizou': {
    displayName: 'Bergs, Zizou',
    logoUrl: 'flags/belgium.webp',
  },
  'Duckworth, James': {
    displayName: 'Duckworth, James',
    logoUrl: 'flags/australia.webp',
  },
  'Jodar, Rafael': {
    displayName: 'Jodar, Rafael',
    logoUrl: 'flags/spain.webp',
  },
  'Machac, Tomas': {
    displayName: 'Machac, Tomas',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Kopriva, Vit': {
    displayName: 'Kopriva, Vit',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Struff, Jan-Lennard': {
    displayName: 'Struff, Jan-Lennard',
    logoUrl: 'flags/germany.webp',
  },
  'Royer, Valentin': {
    displayName: 'Royer, Valentin',
    logoUrl: 'flags/france.webp',
  },
  'Fritz, Taylor': {
    displayName: 'Fritz, Taylor',
    logoUrl: 'flags/united_states.webp',
  },
  'Gaston, Hugo': {
    displayName: 'Gaston, Hugo',
    logoUrl: 'flags/france.webp',
  },
  'Mochizuki, Shintaro': {
    displayName: 'Mochizuki, Shintaro',
    logoUrl: 'flags/japan.webp',
  },
  'Tsitsipas, Stefanos': {
    displayName: 'Tsitsipas, Stefanos',
    logoUrl: 'flags/greece.webp',
  },
  'Tiafoe, Frances': {
    displayName: 'Tiafoe, Frances',
    logoUrl: 'flags/united_states.webp',
  },
  'Zheng, Michael': {
    displayName: 'Zheng, Michael',
    logoUrl: 'flags/united_states.webp',
  },
  'Fucsovics, Marton': {
    displayName: 'Fucsovics, Marton',
    logoUrl: 'flags/hungary.webp',
  },
  'Nava, Emilio': {
    displayName: 'Nava, Emilio',
    logoUrl: 'flags/usa.webp',
  },
  'Alcaraz, Carlos': {
    displayName: 'Alcaraz, Carlos',
    logoUrl: 'flags/spain.webp',
  },
  'Halys, Quentin': {
    displayName: 'Halys, Quentin',
    logoUrl: 'flags/france.webp',
  },
  'Medjedovic, Hamad': {
    displayName: 'Medjedovic, Hamad',
    logoUrl: 'flags/serbia.webp',
  },
  'Thompson, Jordan': {
    displayName: 'Thompson, Jordan',
    logoUrl: 'flags/australia.webp',
  },
  'Shevchenko, Alexander': {
    displayName: 'Shevchenko, Alexander',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Shapovalov, Denis': {
    displayName: 'Shapovalov, Denis',
    logoUrl: 'flags/canada.webp',
  },
  'Cilic, Marin': {
    displayName: 'Cilic, Marin',
    logoUrl: 'flags/croatia.webp',
  },
  'Van de Zandschulp, Botic': {
    displayName: 'Van de Zandschulp, Botic',
    logoUrl: 'flags/netherlands.webp',
  },
  'Shang, Juncheng': {
    displayName: 'Shang, Juncheng',
    logoUrl: 'flags/china.webp',
  },
  'Majchrzak, Kamil': {
    displayName: 'Majchrzak, Kamil',
    logoUrl: 'flags/poland.webp',
  },
  'Marozsan, Fabian': {
    displayName: 'Marozsan, Fabian',
    logoUrl: 'flags/hungary.webp',
  },
  'Hijikata, Rinky': {
    displayName: 'Hijikata, Rinky',
    logoUrl: 'flags/australia.webp',
  },
  'Gea, Arthur': {
    displayName: 'Gea, Arthur',
    logoUrl: 'flags/france.webp',
  },
  'Maestrelli, Francesco': {
    displayName: 'Maestrelli, Francesco',
    logoUrl: 'flags/italy.webp',
  },
  'Ruud, Casper': {
    displayName: 'Ruud, Casper',
    logoUrl: 'flags/norway.webp',
  },
  'Grabher, Julia': {
    displayName: 'Grabher, Julia',
    logoUrl: 'flags/austria.webp',
  },
  'Pliskova, Karolina': {
    displayName: 'Pliskova, Karolina',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Sun, Lulu': {
    displayName: 'Sun, Lulu',
    logoUrl: 'flags/new_zealand.webp',
  },
  'Kartal, Sonay': {
    displayName: 'Kartal, Sonay',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Ostapenko, Jelena': {
    displayName: 'Ostapenko, Jelena',
    logoUrl: 'flags/latvia.webp',
  },
  'Lys, Eva': {
    displayName: 'Lys, Eva',
    logoUrl: 'flags/germany.webp',
  },
  'Siegemund, Laura': {
    displayName: 'Siegemund, Laura',
    logoUrl: 'flags/germany.webp',
  },
  'Samsonova, Liudmila': {
    displayName: 'Samsonova, Liudmila',
    logoUrl: 'flags/russia.webp',
  },
  'Boulter, Katie': {
    displayName: 'Boulter, Katie',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Osaka, Naomi': {
    displayName: 'Osaka, Naomi',
    logoUrl: 'flags/japan.webp',
  },
  'Potapova, Anastasia': {
    displayName: 'Potapova, Anastasia',
    logoUrl: 'flags/russia.webp',
  },
  'Raducanu, Emma': {
    displayName: 'Raducanu, Emma',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Marcinko, Petra': {
    displayName: 'Marcinko, Petra',
    logoUrl: 'flags/croatia.webp',
  },
  'Baptiste, Hailey': {
    displayName: 'Baptiste, Hailey',
    logoUrl: 'flags/united_states.webp',
  },
  'Frech, Magdalena': {
    displayName: 'Frech, Magdalena',
    logoUrl: 'flags/poland.webp',
  },
  'Kessler, McCartney': {
    displayName: 'Kessler, McCartney',
    logoUrl: 'flags/united_states.webp',
  },
  'Kudermetova, Polina': {
    displayName: 'Kudermetova, Polina',
    logoUrl: 'flags/russia.webp',
  },
  'Tauson, Clara': {
    displayName: 'Tauson, Clara',
    logoUrl: 'flags/denmark.webp',
  },
  'Muchova, Karolina': {
    displayName: 'Muchova, Karolina',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Hon, Priscilla': {
    displayName: 'Hon, Priscilla',
    logoUrl: 'flags/australia.webp',
  },
  'McNally, Caty': {
    displayName: 'McNally, Caty',
    logoUrl: 'flags/united_states.webp',
  },
  'Badosa, Paula': {
    displayName: 'Badosa, Paula',
    logoUrl: 'flags/spain.webp',
  },
  'Ruse, Elena-Gabriela': {
    displayName: 'Ruse, Elena-Gabriela',
    logoUrl: 'flags/romania.webp',
  },
  'Sakkari, Maria': {
    displayName: 'Sakkari, Maria',
    logoUrl: 'flags/greece.webp',
  },
  'Andreeva, Mirra': {
    displayName: 'Andreeva, Mirra',
    logoUrl: 'flags/russia.webp',
  },
  'Bouzkova, Marie': {
    displayName: 'Bouzkova, Marie',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Mertens, Elise': {
    displayName: 'Mertens, Elise',
    logoUrl: 'flags/belgium.webp',
  },
  'Uchijima, Moyuka': {
    displayName: 'Uchijima, Moyuka',
    logoUrl: 'flags/japan.webp',
  },
  'Choinski, Jan': {
    displayName: 'Choinski, Jan',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Fils, Arthur': {
    displayName: 'Fils, Arthur',
    logoUrl: 'flags/france.webp',
  },
  'Vavassori, Andrea': {
    displayName: 'Vavassori, Andrea',
    logoUrl: 'flags/italy.webp',
  },
  'Blanchet, Ugo': {
    displayName: 'Blanchet, Ugo',
    logoUrl: 'flags/france.webp',
  },
  'Basilashvili, Nikoloz': {
    displayName: 'Basilashvili, Nikoloz',
    logoUrl: 'flags/georgia.webp',
  },
  'Kouame, Moise': {
    displayName: 'Kouame, Moise',
    logoUrl: 'flags/france.webp',
  },
  'Kovacevic, Aleksandar': {
    displayName: 'Kovacevic, Aleksandar',
    logoUrl: 'flags/united_states.webp',
  },
  'Oliynykova, Oleksandra': {
    displayName: 'Oliynykova, Oleksandra',
    logoUrl: 'flags/croatia.webp',
  },
  'Valdmannova, Vendula': {
    displayName: 'Valdmannova, Vendula',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Sorribes Tormo, Sara': {
    displayName: 'Sorribes Tormo, Sara',
    logoUrl: 'flags/spain.webp',
  },
  'Havlickova, Lucie': {
    displayName: 'Havlickova, Lucie',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Rakotomanga Rajaonah, Tiantsoa Sarah': {
    displayName: 'Rakotomanga Rajaonah, Tiantsoa Sarah',
    logoUrl: 'flags/france.webp',
  },
  'Kraus, Sinja': {
    displayName: 'Kraus, Sinja',
    logoUrl: 'flags/austria.webp',
  },
  'Volynets, Katie': {
    displayName: 'Volynets, Katie',
    logoUrl: 'flags/united_states.webp',
  },
  'Waltert, Simona': {
    displayName: 'Waltert, Simona',
    logoUrl: 'flags/switzerland.webp',
  },
  'Martincova, Tereza': {
    displayName: 'Martincova, Tereza',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Avanesyan, Elina': {
    displayName: 'Avanesyan, Elina',
    logoUrl: 'flags/armenia.webp',
  },
  'Yastremska, Dayana': {
    displayName: 'Yastremska, Dayana',
    logoUrl: 'flags/ukraine.webp',
  },
  'Alexandrova, Ekaterina': {
    displayName: 'Alexandrova, Ekaterina',
    logoUrl: 'flags/russia.webp',
  },
  'Bejlek, Sara': {
    displayName: 'Bejlek, Sara',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Udvardy, Panna': {
    displayName: 'Udvardy, Panna',
    logoUrl: 'flags/hungary.webp',
  },
  'Burruchaga, Roman Andres': {
    displayName: 'Burruchaga, Roman Andres',
    logoUrl: 'flags/argentina.webp',
  },
  'Djere, Laslo': {
    displayName: 'Djere, Laslo',
    logoUrl: 'flags/serbia.webp',
  },
  'Diaz Acosta, Facundo': {
    displayName: 'Diaz Acosta, Facundo',
    logoUrl: 'flags/argentina.webp',
  },
  'Shimabukuro, Sho': {
    displayName: 'Shimabukuro, Sho',
    logoUrl: 'flags/japan.webp',
  },
  'Buse, Ignacio': {
    displayName: 'Buse, Ignacio',
    logoUrl: 'flags/peru.webp',
  },
  'Pinnington Jones, Jack': {
    displayName: 'Pinnington Jones, Jack',
    logoUrl: 'flags/united-kingdom.webp',
  },
  'Coria, Federico': {
    displayName: 'Coria, Federico',
    logoUrl: 'flags/argentina.webp',
  },
  'Berrettini, Matteo': {
    displayName: 'Berrettini, Matteo',
    logoUrl: 'flags/italy.webp',
  },
  'Ugo Carabelli, Camilo': {
    displayName: 'Ugo Carabelli, Camilo',
    logoUrl: 'flags/argentina.webp',
  },
  'Den Ouden, Guy': {
    displayName: 'Den Ouden, Guy',
    logoUrl: 'flags/netherlands.webp',
  },
  'De Jong, Jesper': {
    displayName: 'De Jong, Jesper',
    logoUrl: 'flags/netherlands.webp',
  },
  'Navone, Mariano': {
    displayName: 'Navone, Mariano',
    logoUrl: 'flags/argentina.webp',
  },
  'Dellien, Hugo': {
    displayName: 'Dellien, Hugo',
    logoUrl: 'flags/bolivia.webp',
  },
  'Walton, Adam': {
    displayName: 'Walton, Adam',
    logoUrl: 'flags/australia.webp',
  },
  'Mannarino, Adrian': {
    displayName: 'Mannarino, Adrian',
    logoUrl: 'flags/france.webp',
  },
  'Svajda, Trevor': {
    displayName: 'Svajda, Trevor',
    logoUrl: 'flags/usa.webp',
  },
  'Popyrin, Alexei': {
    displayName: 'Popyrin, Alexei',
    logoUrl: 'flags/australia.webp',
  },
  'Svajda, Zachary': {
    displayName: 'Svajda, Zachary',
    logoUrl: 'flags/united_states.webp',
  },
  'Taberner, Carlos': {
    displayName: 'Taberner, Carlos',
    logoUrl: 'flags/spain.webp',
  },
  'Barrios Vera, Marcelo Tomas': {
    displayName: 'Barrios Vera, Marcelo Tomas',
    logoUrl: 'flags/chile.webp',
  },
  'Cerundolo, Juan Manuel': {
    displayName: 'Cerundolo, Juan Manuel',
    logoUrl: 'flags/argentina.webp',
  },
  'Monteiro, Thiago': {
    displayName: 'Monteiro, Thiago',
    logoUrl: 'flags/brazil.webp',
  },
  'Bellucci, Mattia': {
    displayName: 'Bellucci, Mattia',
    logoUrl: 'flags/italy.webp',
  },
  'Miguel, Luis Guto': {
    displayName: 'Miguel, Luis Guto',
    logoUrl: 'flags/brazil.webp',
  },
  'Gaubas, Vilius': {
    displayName: 'Gaubas, Vilius',
    logoUrl: 'flags/lithuania.webp',
  },
  'Atmane, Terence': {
    displayName: 'Atmane, Terence',
    logoUrl: 'flags/france.webp',
  },
  'Mpetshi Perricard, G': {
    displayName: 'Mpetshi Perricard, G',
    logoUrl: 'flags/france.webp',
  },
  'Engel, Justin': {
    displayName: 'Engel, Justin',
    logoUrl: 'flags/germany.webp',
  },
  'Davidovich Fokina, A': {
    displayName: 'Davidovich Fokina, A',
    logoUrl: 'flags/spain.webp',
  },
  'De Minaur, Alex': {
    displayName: 'De Minaur, Alex',
    logoUrl: 'flags/australia.webp',
  },
  'Butvilas, Edas': {
    displayName: 'Butvilas, Edas',
    logoUrl: 'flags/lithuania.webp',
  },
  'Tabur, Clement': {
    displayName: 'Tabur, Clement',
    logoUrl: 'flags/france.webp',
  },
  'Vandewinkel, Hanne': {
    displayName: 'Vandewinkel, Hanne',
    logoUrl: 'flags/belgium.webp',
  },
  'Teichmann, Jil': {
    displayName: 'Teichmann, Jil',
    logoUrl: 'flags/switzerland.webp',
  },
  'Nahimana, Sada': {
    displayName: 'Nahimana, Sada',
    logoUrl: 'flags/burundi.webp',
  },
  'Fita Boluda, Angela': {
    displayName: 'Fita Boluda, Angela',
    logoUrl: 'flags/spain.webp',
  },
  'Kabbaj, Yasmine': {
    displayName: 'Kabbaj, Yasmine',
    logoUrl: 'flags/morocco.webp',
  },
  'Cengiz, Berfu': {
    displayName: 'Cengiz, Berfu',
    logoUrl: 'flags/turkey.webp',
  },
  'El Jardi, D': {
    displayName: 'El Jardi, D',
    logoUrl: 'flags/morocco.webp',
  },
  'Kotliar, Yelyzaveta': {
    displayName: 'Kotliar, Yelyzaveta',
    logoUrl: 'flags/ukraine.webp',
  },
  'Hercog, Polona': {
    displayName: 'Hercog, Polona',
    logoUrl: 'flags/slovenia.webp',
  },
  'Bautista Agut, Roberto': {
    displayName: 'Bautista Agut, Roberto',
    logoUrl: 'flags/spain.webp',
  },
  'Kyrgios, Nick': {
    displayName: 'Kyrgios, Nick',
    logoUrl: 'flags/australia.webp',
  },
  'Dedura, Diego': {
    displayName: 'Dedura, Diego',
    logoUrl: 'flags/germany.webp',
  },
  'Gentzsch, Tom': {
    displayName: 'Gentzsch, Tom',
    logoUrl: 'flags/germany.webp',
  },
  'Virtanen, Otto': {
    displayName: 'Virtanen, Otto',
    logoUrl: 'flags/finland.webp',
  },
  'Boogaard, Thijs': {
    displayName: 'Boogaard, Thijs',
    logoUrl: 'flags/netherlands.webp',
  },
  'Zhang, Zhizhen': {
    displayName: 'Zhang, Zhizhen',
    logoUrl: 'flags/china.webp',
  },
  'Bouzas Maneiro, Jessica': {
    displayName: 'Bouzas Maneiro, Jessica',
    logoUrl: 'flags/spain.webp',
  },
  'Ruse, Elena': {
    displayName: 'Ruse, Elena',
    logoUrl: 'flags/romania.webp',
  },
  'Lamens, Suzan': {
    displayName: 'Lamens, Suzan',
    logoUrl: 'flags/netherlands.webp',
  },
  'Andreescu, Bianca': {
    displayName: 'Andreescu, Bianca',
    logoUrl: 'flags/canada.webp',
  },
  'Zheng, Qinwen': {
    displayName: 'Zheng, Qinwen',
    logoUrl: 'flags/china.webp',
  },
  'Stojsavljevic, Mika': {
    displayName: 'Stojsavljevic, Mika',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Jones, Francesca': {
    displayName: 'Jones, Francesca',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Zdenek Kolar': {
    displayName: 'Zdenek Kolar',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Nicolai Budkov Kjaer': {
    displayName: 'Nicolai Budkov Kjaer',
    logoUrl: 'flags/norway.webp',
  },
  'Andrea Pellegrino': {
    displayName: 'Andrea Pellegrino',
    logoUrl: 'flags/italy.webp',
  },
  'Dylan Dietrich': {
    displayName: 'Dylan Dietrich',
    logoUrl: 'flags/switzerland.webp',
  },
  'Lautaro Midon': {
    displayName: 'Lautaro Midon',
    logoUrl: 'flags/argentina.webp',
  },
  'Adolfo Vallejo': {
    displayName: 'Adolfo Vallejo',
    logoUrl: 'flags/paraguay.webp',
  },
  'Miguel Damas': {
    displayName: 'Miguel Damas',
    logoUrl: 'flags/spain.webp',
  },
  'Taro Daniel': {
    displayName: 'Taro Daniel',
    logoUrl: 'flags/japan.webp',
  },
  'Jan Choinksi': {
    displayName: 'Jan Choinksi',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Federico Cina': {
    displayName: 'Federico Cina',
    logoUrl: 'flags/italy.webp',
  },
  'Martin Krumich': {
    displayName: 'Martin Krumich',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Aleksandr Shevchenko': {
    displayName: 'Aleksandr Shevchenko',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Max Dahlin': {
    displayName: 'Max Dahlin',
    logoUrl: 'flags/sweden.webp',
  },
  'Matej Dodig': {
    displayName: 'Matej Dodig',
    logoUrl: 'flags/croatia.webp',
  },
  'Alex Molcan': {
    displayName: 'Alex Molcan',
    logoUrl: 'flags/slovakia.webp',
  },
  'Marko Topo': {
    displayName: 'Marko Topo',
    logoUrl: 'flags/germany.webp',
  },
  'Kaitlin Quevedo': {
    displayName: 'Kaitlin Quevedo',
    logoUrl: 'flags/spain.webp',
  },
  'Leolia Jeanjean': {
    displayName: 'Leolia Jeanjean',
    logoUrl: 'flags/france.webp',
  },
  'Mayar Sherif': {
    displayName: 'Mayar Sherif',
    logoUrl: 'flags/egypt.webp',
  },
  'Alevtina Ibragimova': {
    displayName: 'Alevtina Ibragimova',
    logoUrl: 'flags/russia.webp',
  },
  'Ipek Oz': {
    displayName: 'Ipek Oz',
    logoUrl: 'flags/turkey.webp',
  },
  'Miriam Bulgaru': {
    displayName: 'Miriam Bulgaru',
    logoUrl: 'flags/romania.webp',
  },
  'Leyre Romero Gormaz': {
    displayName: 'Leyre Romero Gormaz',
    logoUrl: 'flags/spain.webp',
  },
  'Carole Monnet': {
    displayName: 'Carole Monnet',
    logoUrl: 'flags/france.webp',
  },
  'Aoi Ito': {
    displayName: 'Aoi Ito',
    logoUrl: 'flags/japan.webp',
  },
  'Alina Korneeva': {
    displayName: 'Alina Korneeva',
    logoUrl: 'flags/russia.webp',
  },
  'Katarzyna Kawa': {
    displayName: 'Katarzyna Kawa',
    logoUrl: 'flags/poland.webp',
  },
  'Sapfo Sakellaridi': {
    displayName: 'Sapfo Sakellaridi',
    logoUrl: 'flags/greece.webp',
  },
  'Miriana Tona': {
    displayName: 'Miriana Tona',
    logoUrl: 'flags/italy.webp',
  },
  'Ilinca Amariei': {
    displayName: 'Ilinca Amariei',
    logoUrl: 'flags/romania.webp',
  },
  'Sofia Costoulas': {
    displayName: 'Sofia Costoulas',
    logoUrl: 'flags/belgium.webp',
  },
  'Tiago Pereira': {
    displayName: 'Tiago Pereira',
    logoUrl: 'flags/portugal.webp',
  },
  'Adolfo Daniel Vallejo': {
    displayName: 'Adolfo Daniel Vallejo',
    logoUrl: 'flags/paraguay.webp',
  },
  'Kilian Feldbausch': {
    displayName: 'Kilian Feldbausch',
    logoUrl: 'flags/switzerland.webp',
  },
  'Orlando Luz': {
    displayName: 'Orlando Luz',
    logoUrl: 'flags/brazil.webp',
  },
  'Tiago Torres': {
    displayName: 'Tiago Torres',
    logoUrl: 'flags/portugal.webp',
  },
  'Jurij Rodionov': {
    displayName: 'Jurij Rodionov',
    logoUrl: 'flags/austria.webp',
  },
  'Timofey Skatov': {
    displayName: 'Timofey Skatov',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Skatov, Timofey': {
    displayName: 'Skatov, Timofey',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Alina Charaeva': {
    displayName: 'Alina Charaeva',
    logoUrl: 'flags/russia.webp',
  },
  'Charaeva, Alina': {
    displayName: 'Charaeva, Alina',
    logoUrl: 'flags/russia.webp',
  },
  'Aidan Mayo': {
    displayName: 'Aidan Mayo',
    logoUrl: 'flags/united_states.webp',
  },
  'Edward Winter': {
    displayName: 'Edward Winter',
    logoUrl: 'flags/australia.webp',
  },
  'Kei Nishikori': {
    displayName: 'Kei Nishikori',
    logoUrl: 'flags/japan.webp',
  },
  'Rodrigo Pacheco Mendez': {
    displayName: 'Rodrigo Pacheco Mendez',
    logoUrl: 'flags/mexico.webp',
  },
  'Soonwoo Kwon': {
    displayName: 'Soonwoo Kwon',
    logoUrl: 'flags/south_korea.webp',
  },
  'Kristina Liutova': {
    displayName: 'Kristina Liutova',
    logoUrl: 'flags/russia.webp',
  },
  'Ye-Xin Ma': {
    displayName: 'Ye-Xin Ma',
    logoUrl: 'flags/china.webp',
  },
  'Ariana Arseneault': {
    displayName: 'Ariana Arseneault',
    logoUrl: 'flags/canada.webp',
  },
  'Cadence Brace': {
    displayName: 'Cadence Brace',
    logoUrl: 'flags/canada.webp',
  },
  'Carol Zhao': {
    displayName: 'Carol Zhao',
    logoUrl: 'flags/canada.webp',
  },
  'Jack Draper': {
    displayName: 'Jack Draper',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Kayla Cross': {
    displayName: 'Kayla Cross',
    logoUrl: 'flags/canada.webp',
  },
  'Rebecca Marino': {
    displayName: 'Rebecca Marino',
    logoUrl: 'flags/canada.webp',
  },
  'Xiyu Wang': {
    displayName: 'Xiyu Wang',
    logoUrl: 'flags/china.webp',
  },
  'Linda Noskova': {
    displayName: 'Linda Noskova',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Noskova, Linda': {
    displayName: 'Noskova, Linda',
    logoUrl: 'flags/czech_republic.webp',
  },
  'B Van de Zandschulp': {
    displayName: 'B Van de Zandschulp',
    logoUrl: 'flags/netherlands.webp',
  },
  'Cruz Hewitt': {
    displayName: 'Cruz Hewitt',
    logoUrl: 'flags/australia.webp',
  },
  'Hewitt, Cruz': {
    displayName: 'Hewitt, Cruz',
    logoUrl: 'flags/australia.webp',
  },
  'Roman Safiullin': {
    displayName: 'Roman Safiullin',
    logoUrl: 'flags/russia.webp',
  },
  'Safiullin, Roman': {
    displayName: 'Safiullin, Roman',
    logoUrl: 'flags/russia.webp',
  },
  'Mees Rottgering': {
    displayName: 'Mees Rottgering',
    logoUrl: 'flags/netherlands.webp',
  },
  'Rottgering, Mees': {
    displayName: 'Rottgering, Mees',
    logoUrl: 'flags/netherlands.webp',
  },
};
